const getMrTimings = () => {
    return {
        stats: {
            total_accepted_count: 9,
            total_approved_count: 34,
            total_commented_count: 34,
            mrs: [
                {
                    mr_id: "1879323598",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 286483,
                    under_review_duration_sec: 229229,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1894851405",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 83489,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1942892797",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 1991595,
                    under_review_duration_sec: 1656002,
                    approval_to_merge_duration_sec: 170213,
                },
                {
                    mr_id: "1931529768",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 324958,
                    under_review_duration_sec: 0,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1967205383",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 80447,
                    under_review_duration_sec: 858008,
                    approval_to_merge_duration_sec: 103660,
                },
                {
                    mr_id: "1976876266",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 605828,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1926905135",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 1768,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1890736322",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 95326,
                    under_review_duration_sec: 98818,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1896792989",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 104851,
                    under_review_duration_sec: 72892,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1928906518",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 56513,
                    under_review_duration_sec: 18287,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1972315426",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 715,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1645030921",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 918,
                    under_review_duration_sec: 655,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1829962388",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 14,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1974682780",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 0,
                    under_review_duration_sec: 78958,
                    approval_to_merge_duration_sec: 0,
                },
                {
                    mr_id: "1929324135",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 4007,
                    under_review_duration_sec: 11055,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1978454761",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 340056,
                    under_review_duration_sec: 1213,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1809927387",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 338,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1885180316",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 7499,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1976783277",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 2,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1896212142",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 30,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1930679023",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 0,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1970017060",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 171,
                    under_review_duration_sec: 0,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1933129291",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 6019,
                    under_review_duration_sec: 179,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1967149897",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 180947,
                    under_review_duration_sec: 2493,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1971917461",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 720,
                    under_review_duration_sec: 22192,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1864552589",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 13647,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1903604409",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 780,
                    under_review_duration_sec: 12119,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1907715152",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 158888,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1929221180",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 4553,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1962771256",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 418796,
                    under_review_duration_sec: 3123,
                    approval_to_merge_duration_sec: 701895,
                },
                {
                    mr_id: "1981897209",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 473,
                    under_review_duration_sec: 78157,
                    approval_to_merge_duration_sec: 80776,
                },
                {
                    mr_id: "1982198129",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 3193,
                    under_review_duration_sec: 58594,
                    approval_to_merge_duration_sec: 100336,
                },
                {
                    mr_id: "1982142138",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 342,
                    under_review_duration_sec: 1364,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1978704805",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 255579,
                    under_review_duration_sec: 0,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1970039612",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 88,
                    under_review_duration_sec: 0,
                    approval_to_merge_duration_sec: 780392,
                },
                {
                    mr_id: "1917360902",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 4485,
                    under_review_duration_sec: 438306,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1978394673",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 359898,
                    under_review_duration_sec: 350,
                    approval_to_merge_duration_sec: 66865,
                },
                {
                    mr_id: "1985756903",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 384,
                    under_review_duration_sec: 2700,
                    approval_to_merge_duration_sec: 9029,
                },
                {
                    mr_id: "1985787985",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 149768,
                    under_review_duration_sec: 1438,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1920789020",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 196,
                    under_review_duration_sec: 3464700,
                    approval_to_merge_duration_sec: 0,
                },
                {
                    mr_id: "1960642799",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 3026446,
                    under_review_duration_sec: 266243,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1910278918",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 559,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1924764107",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 427714,
                    under_review_duration_sec: 3302,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1894704670",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 199,
                    under_review_duration_sec: 151925,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1938663837",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 1805668,
                    under_review_duration_sec: 2674,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1962828841",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 426,
                    under_review_duration_sec: 1057,
                    approval_to_merge_duration_sec: 709681,
                },
                {
                    mr_id: "1981887193",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 353058,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1892686615",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 440,
                    under_review_duration_sec: 83011,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1931306523",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 136,
                    under_review_duration_sec: null,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1938722729",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 1457,
                    under_review_duration_sec: 61702,
                    approval_to_merge_duration_sec: null,
                },
                {
                    mr_id: "1967002122",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 593366,
                    under_review_duration_sec: 258797,
                    approval_to_merge_duration_sec: 338658,
                },
                {
                    mr_id: "1983535169",
                    hostname_repo_full_name: "https://api.github.com:demo/demo",
                    in_progress_duration_sec: 683,
                    under_review_duration_sec: 2433,
                    approval_to_merge_duration_sec: null,
                },
            ],
            in_progress_duration_adj_avg: 82579,
            in_progress_duration_avg: 226037,
            in_progress_duration_median: 4246,
            in_progress_duration_25th: 416,
            in_progress_duration_75th: 199605,
            "90thInProgressDuration": 426822,
            in_progress_duration_95th: 1145756,
            in_progress_duration_99th: 2498672,
            under_review_duration_adj_avg: 54463,
            under_review_duration_avg: 220610,
            under_review_duration_median: 11587,
            under_review_duration_25th: 1326,
            under_review_duration_75th: 86963,
            under_review_duration_90th: 352275,
            under_review_duration_95th: 1057506,
            under_review_duration_99th: 2831656,
            approved_to_merge_duration_adj_avg: 196429,
            approved_to_merge_duration_avg: 255125,
            approved_to_merge_duration_median: 101998,
            approved_to_merge_duration_25th: 52406,
            approved_to_merge_duration_75th: 429467,
            approved_to_merge_duration_90th: 708902,
            approved_to_merge_duration_95th: 741501,
            approved_to_merge_duration_99th: 772614,
            timeseries: [
                {
                    week: "2024-01-01 00:00:00",
                    mrs: [
                        {
                            mr_id: "1666716856",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 72,
                        },
                        {
                            mr_id: "1666743425",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 344,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 199,
                        },
                        {
                            mr_id: "1646372715",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 175070,
                            under_review_duration_sec: 1582648,
                            approval_to_merge_duration_sec: 54951,
                        },
                        {
                            mr_id: "1655417457",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 364,
                            under_review_duration_sec: 856,
                            approval_to_merge_duration_sec: 1125416,
                        },
                        {
                            mr_id: "1655282460",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1098,
                            under_review_duration_sec: 5720,
                            approval_to_merge_duration_sec: 1121236,
                        },
                        {
                            mr_id: "1659391605",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 395,
                            under_review_duration_sec: 418223,
                            approval_to_merge_duration_sec: 69643,
                        },
                        {
                            mr_id: "1665290165",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 411,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 74,
                        },
                        {
                            mr_id: "1666911962",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 172,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 84,
                        },
                        {
                            mr_id: "1658500573",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 7022,
                            under_review_duration_sec: 413481,
                            approval_to_merge_duration_sec: 108953,
                        },
                        {
                            mr_id: "1659251627",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 576,
                            under_review_duration_sec: 84886,
                            approval_to_merge_duration_sec: 356871,
                        },
                        {
                            mr_id: "1666788726",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 123,
                        },
                        {
                            mr_id: "1663871043",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 56,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 76,
                        },
                        {
                            mr_id: "1663331064",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 291,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4205,
                        },
                        {
                            mr_id: "1662263370",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 63,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 134,
                        },
                        {
                            mr_id: "1652411655",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 73831,
                            under_review_duration_sec: 20773,
                            approval_to_merge_duration_sec: 1109707,
                        },
                        {
                            mr_id: "1654378098",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2345,
                            under_review_duration_sec: 71004,
                            approval_to_merge_duration_sec: 1120277,
                        },
                        {
                            mr_id: "1665405104",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 216,
                            under_review_duration_sec: 98,
                            approval_to_merge_duration_sec: 403,
                        },
                        {
                            mr_id: "1666823913",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 40,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1954,
                        },
                        {
                            mr_id: "1650946672",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 5981,
                            under_review_duration_sec: 5356,
                            approval_to_merge_duration_sec: 1274340,
                        },
                        {
                            mr_id: "1662318815",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 467,
                            under_review_duration_sec: 86015,
                            approval_to_merge_duration_sec: 70598,
                        },
                        {
                            mr_id: "1662283052",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 69,
                            under_review_duration_sec: 1369,
                            approval_to_merge_duration_sec: 164404,
                        },
                        {
                            mr_id: "1642868658",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 336,
                            under_review_duration_sec: 323,
                            approval_to_merge_duration_sec: 1723920,
                        },
                        {
                            mr_id: "1661935891",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 227,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1880,
                        },
                        {
                            mr_id: "1663291381",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 73,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 362,
                        },
                        {
                            mr_id: "1663877407",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 81,
                            under_review_duration_sec: 87523,
                            approval_to_merge_duration_sec: 100,
                        },
                    ],
                    in_progress_duration_avg: 166957,
                    in_progress_duration_median: 222,
                    in_progress_duration_10th: 36,
                    in_progress_duration_25th: 68,
                    in_progress_duration_75th: 491,
                    in_progress_duration_90th: 75939,
                    in_progress_duration_95th: 459713,
                    in_progress_duration_99th: 2707181,
                    in_progress_duration_adj_avg: 1295,
                    under_review_duration_avg: 167657,
                    under_review_duration_median: 84,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 106494,
                    under_review_duration_90th: 414904,
                    under_review_duration_95th: 912014,
                    under_review_duration_99th: 1473367,
                    under_review_duration_adj_avg: 60625,
                    approved_to_merge_duration_avg: 332399,
                    approved_to_merge_duration_median: 4205,
                    approved_to_merge_duration_10th: 79,
                    approved_to_merge_duration_25th: 134,
                    approved_to_merge_duration_75th: 356871,
                    approved_to_merge_duration_90th: 1123744,
                    approved_to_merge_duration_95th: 1244555,
                    approved_to_merge_duration_99th: 1616021,
                    approved_to_merge_duration_adj_avg: 220320,
                },
                {
                    week: "2024-01-08 00:00:00",
                    mrs: [
                        {
                            mr_id: "1670925294",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 126,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2584,
                        },
                        {
                            mr_id: "1669510992",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 976,
                            under_review_duration_sec: 181698,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1665389466",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 17583,
                            under_review_duration_sec: 2544,
                            approval_to_merge_duration_sec: 673886,
                        },
                        {
                            mr_id: "1649167608",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 876094,
                            under_review_duration_sec: 71558,
                            approval_to_merge_duration_sec: 1980863,
                        },
                        {
                            mr_id: "1671701970",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 17645,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 118,
                        },
                        {
                            mr_id: "1651233397",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3359592,
                            under_review_duration_sec: 266796,
                            approval_to_merge_duration_sec: 333940,
                        },
                        {
                            mr_id: "1665198342",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 100949,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 346479,
                        },
                        {
                            mr_id: "1670804220",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 321,
                            under_review_duration_sec: 4525,
                            approval_to_merge_duration_sec: 2231,
                        },
                        {
                            mr_id: "1669566274",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2769,
                            under_review_duration_sec: 2861,
                            approval_to_merge_duration_sec: 109888,
                        },
                        {
                            mr_id: "1671085141",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 343,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 219,
                        },
                        {
                            mr_id: "1671716031",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 76,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 690,
                        },
                        {
                            mr_id: "1672734690",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 358,
                        },
                        {
                            mr_id: "1675162654",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 163,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2628,
                        },
                        {
                            mr_id: "1657495194",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 594,
                            under_review_duration_sec: 58,
                            approval_to_merge_duration_sec: 1192966,
                        },
                        {
                            mr_id: "1669374796",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3396,
                            under_review_duration_sec: 11008,
                            approval_to_merge_duration_sec: 350553,
                        },
                        {
                            mr_id: "1660090625",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1859,
                            under_review_duration_sec: 348443,
                            approval_to_merge_duration_sec: 604829,
                        },
                        {
                            mr_id: "1662295552",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2132,
                            under_review_duration_sec: 163408,
                            approval_to_merge_duration_sec: 598888,
                        },
                        {
                            mr_id: "1675159712",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 605,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 556,
                        },
                        {
                            mr_id: "1662308452",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 122,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 513980,
                        },
                        {
                            mr_id: "1666471530",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 397,
                            under_review_duration_sec: 10409,
                            approval_to_merge_duration_sec: 246106,
                        },
                        {
                            mr_id: "1660161284",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 248,
                            under_review_duration_sec: 345989,
                            approval_to_merge_duration_sec: 598991,
                        },
                        {
                            mr_id: "1665195218",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 69,
                            approval_to_merge_duration_sec: 353381,
                        },
                        {
                            mr_id: "1671234629",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 437955,
                            under_review_duration_sec: 888,
                            approval_to_merge_duration_sec: 245057,
                        },
                        {
                            mr_id: "1670834445",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 342,
                            under_review_duration_sec: 3458,
                            approval_to_merge_duration_sec: 82510,
                        },
                        {
                            mr_id: "1649620782",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1825128,
                            under_review_duration_sec: 1177902,
                            approval_to_merge_duration_sec: 701386,
                        },
                        {
                            mr_id: "1675084969",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 127,
                            under_review_duration_sec: 2647,
                            approval_to_merge_duration_sec: 84668,
                        },
                        {
                            mr_id: "1670822274",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4340,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4792,
                        },
                        {
                            mr_id: "1672726275",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3158,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 164,
                        },
                        {
                            mr_id: "1671015790",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 250,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 206,
                        },
                        {
                            mr_id: "1669201810",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 189,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 838,
                        },
                        {
                            mr_id: "1672568349",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 338,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1498,
                        },
                        {
                            mr_id: "1671028012",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 66,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1225,
                        },
                    ],
                    in_progress_duration_avg: 68990,
                    in_progress_duration_median: 465,
                    in_progress_duration_10th: 126,
                    in_progress_duration_25th: 250,
                    in_progress_duration_75th: 4340,
                    in_progress_duration_90th: 161969,
                    in_progress_duration_95th: 472023,
                    in_progress_duration_99th: 794075,
                    in_progress_duration_adj_avg: 8243,
                    under_review_duration_avg: 26556,
                    under_review_duration_median: 2,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 3725,
                    under_review_duration_90th: 63595,
                    under_review_duration_95th: 225568,
                    under_review_duration_99th: 262043,
                    under_review_duration_adj_avg: 1835,
                    approved_to_merge_duration_avg: 282390,
                    approved_to_merge_duration_median: 83589,
                    approved_to_merge_duration_10th: 207,
                    approved_to_merge_duration_25th: 801,
                    approved_to_merge_duration_75th: 393531,
                    approved_to_merge_duration_90th: 666980,
                    approved_to_merge_duration_95th: 922597,
                    approved_to_merge_duration_99th: 1736615,
                    approved_to_merge_duration_adj_avg: 186954,
                },
                {
                    week: "2024-01-15 00:00:00",
                    mrs: [
                        {
                            mr_id: "1662440378",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 921581,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 861208,
                        },
                        {
                            mr_id: "1685172023",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 17695,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 30166,
                        },
                        {
                            mr_id: "1676485508",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 867,
                            under_review_duration_sec: 262214,
                            approval_to_merge_duration_sec: 95141,
                        },
                        {
                            mr_id: "1663996220",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 523024,
                            under_review_duration_sec: 1172983,
                            approval_to_merge_duration_sec: 102478,
                        },
                        {
                            mr_id: "1677396432",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 91780,
                            under_review_duration_sec: 221872,
                            approval_to_merge_duration_sec: 169400,
                        },
                        {
                            mr_id: "1677508526",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 465,
                            under_review_duration_sec: 475813,
                            approval_to_merge_duration_sec: 7595,
                        },
                        {
                            mr_id: "1679698538",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 161068,
                            under_review_duration_sec: 39,
                            approval_to_merge_duration_sec: 3028,
                        },
                        {
                            mr_id: "1673052179",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 5221,
                            under_review_duration_sec: 418164,
                            approval_to_merge_duration_sec: 263418,
                        },
                        {
                            mr_id: "1675048978",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 444,
                            under_review_duration_sec: 12980,
                            approval_to_merge_duration_sec: 698736,
                        },
                        {
                            mr_id: "1677265179",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 382,
                            under_review_duration_sec: 88,
                            approval_to_merge_duration_sec: 327047,
                        },
                        {
                            mr_id: "1681128102",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 303,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 76,
                        },
                        {
                            mr_id: "1679730421",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 474,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 279,
                        },
                        {
                            mr_id: "1659166665",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 174,
                            under_review_duration_sec: 1547079,
                            approval_to_merge_duration_sec: 182981,
                        },
                        {
                            mr_id: "1658592782",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 760,
                            under_review_duration_sec: 1679596,
                            approval_to_merge_duration_sec: 98784,
                        },
                        {
                            mr_id: "1671538361",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4072,
                            under_review_duration_sec: 249191,
                            approval_to_merge_duration_sec: 496393,
                        },
                        {
                            mr_id: "1681898735",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1758,
                            under_review_duration_sec: 4,
                            approval_to_merge_duration_sec: 1261,
                        },
                        {
                            mr_id: "1679595783",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 83,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 210,
                        },
                        {
                            mr_id: "1679609603",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 157,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4203,
                        },
                        {
                            mr_id: "1681449978",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 37,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 339,
                        },
                        {
                            mr_id: "1681459911",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 57,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1444,
                        },
                        {
                            mr_id: "1681492816",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 245,
                        },
                        {
                            mr_id: "1681500527",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2062,
                        },
                        {
                            mr_id: "1683361019",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 43,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 122,
                        },
                        {
                            mr_id: "1683467216",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 438,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 504,
                        },
                        {
                            mr_id: "1681982058",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 543638,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4094,
                        },
                        {
                            mr_id: "1678287915",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 164,
                            under_review_duration_sec: 3,
                            approval_to_merge_duration_sec: 14399,
                        },
                        {
                            mr_id: "1674538485",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 456,
                            under_review_duration_sec: 462725,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1685167891",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1292147,
                            under_review_duration_sec: 409,
                            approval_to_merge_duration_sec: 96400,
                        },
                        {
                            mr_id: "1683644486",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 518,
                            under_review_duration_sec: 564,
                            approval_to_merge_duration_sec: 28,
                        },
                        {
                            mr_id: "1679500830",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3354,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 529,
                        },
                        {
                            mr_id: "1681359544",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 193,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1311,
                        },
                        {
                            mr_id: "1681291106",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 27,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 72,
                        },
                        {
                            mr_id: "1682052433",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 114,
                        },
                        {
                            mr_id: "1683229734",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 238,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 56,
                        },
                        {
                            mr_id: "1683334446",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 274,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 357,
                        },
                        {
                            mr_id: "1683674398",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 90,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1438,
                        },
                        {
                            mr_id: "1683714729",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 174,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 139,
                        },
                        {
                            mr_id: "1685216042",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 154,
                        },
                        {
                            mr_id: "1674830693",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 75368,
                            under_review_duration_sec: 4631,
                            approval_to_merge_duration_sec: 429082,
                        },
                        {
                            mr_id: "1681465290",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 279,
                            under_review_duration_sec: 149,
                            approval_to_merge_duration_sec: 161,
                        },
                        {
                            mr_id: "1681413349",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 221,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1219,
                        },
                        {
                            mr_id: "1679533189",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1448,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1936,
                        },
                        {
                            mr_id: "1679739224",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 217,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 246,
                        },
                        {
                            mr_id: "1679882488",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 141,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 171,
                        },
                        {
                            mr_id: "1683492298",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 49,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 120,
                        },
                        {
                            mr_id: "1685073623",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 38,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 68,
                        },
                        {
                            mr_id: "1683746157",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 45,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 165,
                        },
                        {
                            mr_id: "1683771259",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 145,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 174,
                        },
                        {
                            mr_id: "1685160001",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 96,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 94,
                        },
                    ],
                    in_progress_duration_avg: 66638,
                    in_progress_duration_median: 221,
                    in_progress_duration_10th: 35,
                    in_progress_duration_25th: 57,
                    in_progress_duration_75th: 1578,
                    in_progress_duration_90th: 161068,
                    in_progress_duration_95th: 353703,
                    in_progress_duration_99th: 992743,
                    in_progress_duration_adj_avg: 8641,
                    under_review_duration_avg: 148685,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 486,
                    under_review_duration_90th: 435988,
                    under_review_duration_95th: 963832,
                    under_review_duration_99th: 1618638,
                    under_review_duration_adj_avg: 39285,
                    approved_to_merge_duration_avg: 79585,
                    approved_to_merge_duration_median: 1219,
                    approved_to_merge_duration_10th: 75,
                    approved_to_merge_duration_25th: 161,
                    approved_to_merge_duration_75th: 30166,
                    approved_to_merge_duration_90th: 276144,
                    approved_to_merge_duration_95th: 469469,
                    approved_to_merge_duration_99th: 783221,
                    approved_to_merge_duration_adj_avg: 27871,
                },
                {
                    week: "2024-01-22 00:00:00",
                    mrs: [
                        {
                            mr_id: "1682045749",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 353703,
                            under_review_duration_sec: 149089,
                            approval_to_merge_duration_sec: 438444,
                        },
                        {
                            mr_id: "1690459420",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 499,
                            under_review_duration_sec: 201,
                            approval_to_merge_duration_sec: 448,
                        },
                        {
                            mr_id: "1690286189",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2393,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 276,
                        },
                        {
                            mr_id: "1690403214",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 65,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 564,
                        },
                        {
                            mr_id: "1690495341",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 331,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 146,
                        },
                        {
                            mr_id: "1692359328",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 273,
                            under_review_duration_sec: 10,
                            approval_to_merge_duration_sec: 7928,
                        },
                        {
                            mr_id: "1675282832",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 523124,
                            under_review_duration_sec: 2784,
                            approval_to_merge_duration_sec: 940561,
                        },
                        {
                            mr_id: "1692216021",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 87501,
                            under_review_duration_sec: 853,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1683742234",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 6367,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 686984,
                        },
                        {
                            mr_id: "1690534767",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 40,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 174,
                        },
                        {
                            mr_id: "1691988117",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 594,
                        },
                        {
                            mr_id: "1691949317",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 153,
                            under_review_duration_sec: 8829,
                            approval_to_merge_duration_sec: 10366,
                        },
                        {
                            mr_id: "1692290725",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3548289,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 420,
                        },
                        {
                            mr_id: "1690874056",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2241896,
                            under_review_duration_sec: 41877,
                            approval_to_merge_duration_sec: 4708,
                        },
                        {
                            mr_id: "1688676669",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 87018,
                            under_review_duration_sec: 87293,
                            approval_to_merge_duration_sec: 96580,
                        },
                        {
                            mr_id: "1694067907",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 72,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 163,
                        },
                        {
                            mr_id: "1692534547",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 47,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 689,
                        },
                        {
                            mr_id: "1690208864",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2863,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 160,
                        },
                        {
                            mr_id: "1690359280",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 155,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1583,
                        },
                        {
                            mr_id: "1690540632",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 139,
                        },
                        {
                            mr_id: "1692017599",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3137,
                        },
                        {
                            mr_id: "1692527126",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 152,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 240,
                        },
                        {
                            mr_id: "1692243072",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1116974,
                            under_review_duration_sec: 1655,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1690338679",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 251392,
                            under_review_duration_sec: 4789,
                            approval_to_merge_duration_sec: 84190,
                        },
                        {
                            mr_id: "1663877092",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 562,
                            under_review_duration_sec: 56283,
                            approval_to_merge_duration_sec: 1942952,
                        },
                        {
                            mr_id: "1687336246",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 518,
                            under_review_duration_sec: 345015,
                            approval_to_merge_duration_sec: 83481,
                        },
                        {
                            mr_id: "1690521548",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 131,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 116,
                        },
                        {
                            mr_id: "1690106927",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 336,
                            under_review_duration_sec: 60,
                            approval_to_merge_duration_sec: 95,
                        },
                        {
                            mr_id: "1690506543",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 199,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 151,
                        },
                        {
                            mr_id: "1675186120",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 179516,
                            under_review_duration_sec: 359618,
                            approval_to_merge_duration_sec: 672832,
                        },
                        {
                            mr_id: "1692356474",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 76977,
                            under_review_duration_sec: 485,
                            approval_to_merge_duration_sec: 161602,
                        },
                        {
                            mr_id: "1694357456",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 508,
                            under_review_duration_sec: 243,
                            approval_to_merge_duration_sec: 169568,
                        },
                        {
                            mr_id: "1679868388",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 257421,
                            under_review_duration_sec: 237855,
                            approval_to_merge_duration_sec: 438955,
                        },
                    ],
                    in_progress_duration_avg: 288045,
                    in_progress_duration_median: 508,
                    in_progress_duration_10th: 39,
                    in_progress_duration_25th: 142,
                    in_progress_duration_75th: 83236,
                    in_progress_duration_90th: 689076,
                    in_progress_duration_95th: 2246116,
                    in_progress_duration_99th: 3067896,
                    in_progress_duration_adj_avg: 65883,
                    under_review_duration_avg: 31376,
                    under_review_duration_median: 130,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 11737,
                    under_review_duration_90th: 79564,
                    under_review_duration_95th: 154333,
                    under_review_duration_99th: 350331,
                    under_review_duration_adj_avg: 9020,
                    approved_to_merge_duration_avg: 174189,
                    approved_to_merge_duration_median: 689,
                    approved_to_merge_duration_10th: 121,
                    approved_to_merge_duration_25th: 163,
                    approved_to_merge_duration_75th: 96580,
                    approved_to_merge_duration_90th: 626057,
                    approved_to_merge_duration_95th: 788415,
                    approved_to_merge_duration_99th: 1622187,
                    approved_to_merge_duration_adj_avg: 60188,
                },
                {
                    week: "2024-01-29 00:00:00",
                    mrs: [
                        {
                            mr_id: "1705103325",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 675976,
                            under_review_duration_sec: 51777,
                            approval_to_merge_duration_sec: 8680,
                        },
                        {
                            mr_id: "1709101697",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 74984,
                            under_review_duration_sec: 111,
                            approval_to_merge_duration_sec: 5410,
                        },
                        {
                            mr_id: "1707313249",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 40,
                            under_review_duration_sec: 61581,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1704859335",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 416,
                            under_review_duration_sec: 7218,
                            approval_to_merge_duration_sec: 3319,
                        },
                        {
                            mr_id: "1690935154",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2284096,
                            under_review_duration_sec: 29,
                            approval_to_merge_duration_sec: 702432,
                        },
                        {
                            mr_id: "1695500414",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 70021,
                            under_review_duration_sec: 32824,
                            approval_to_merge_duration_sec: 415529,
                        },
                        {
                            mr_id: "1707303304",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 19,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 580,
                        },
                        {
                            mr_id: "1704902840",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 146,
                        },
                        {
                            mr_id: "1706762203",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 133,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 96,
                        },
                        {
                            mr_id: "1706774751",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 128,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 660,
                        },
                        {
                            mr_id: "1708837337",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 53,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 535,
                        },
                        {
                            mr_id: "1697427899",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1091,
                            under_review_duration_sec: 6443,
                            approval_to_merge_duration_sec: 444458,
                        },
                        {
                            mr_id: "1696309250",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 5107,
                            under_review_duration_sec: 67221,
                            approval_to_merge_duration_sec: 434425,
                        },
                        {
                            mr_id: "1697695075",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 95,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 245828,
                        },
                        {
                            mr_id: "1704881353",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 136,
                            under_review_duration_sec: 6541,
                            approval_to_merge_duration_sec: 80935,
                        },
                        {
                            mr_id: "1707115192",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 239,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 870,
                        },
                        {
                            mr_id: "1705240434",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3660,
                            under_review_duration_sec: 40894,
                            approval_to_merge_duration_sec: 24414,
                        },
                        {
                            mr_id: "1685319881",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 582102,
                            under_review_duration_sec: 475,
                            approval_to_merge_duration_sec: 780755,
                        },
                        {
                            mr_id: "1685451530",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1578,
                            under_review_duration_sec: 353730,
                            approval_to_merge_duration_sec: 669970,
                        },
                        {
                            mr_id: "1707184009",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 76571,
                            under_review_duration_sec: 1779,
                            approval_to_merge_duration_sec: 73483,
                        },
                        {
                            mr_id: "1692528167",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 87270,
                            under_review_duration_sec: 20461,
                            approval_to_merge_duration_sec: 659468,
                        },
                        {
                            mr_id: "1704497599",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 129,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 119,
                        },
                        {
                            mr_id: "1704882964",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 139,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 209,
                        },
                        {
                            mr_id: "1709304486",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 33,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 769,
                        },
                        {
                            mr_id: "1709290901",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 127,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 133,
                        },
                        {
                            mr_id: "1694461232",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 460,
                            under_review_duration_sec: 59048,
                            approval_to_merge_duration_sec: 621535,
                        },
                        {
                            mr_id: "1704877636",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2,
                            under_review_duration_sec: 41,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1704474446",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 43,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 578,
                        },
                        {
                            mr_id: "1703227379",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 619,
                            under_review_duration_sec: 75548,
                            approval_to_merge_duration_sec: 81717,
                        },
                        {
                            mr_id: "1704848367",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 32,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 371,
                        },
                        {
                            mr_id: "1706903837",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 769,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 5998,
                        },
                        {
                            mr_id: "1707267267",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 190,
                            under_review_duration_sec: 15,
                            approval_to_merge_duration_sec: 590,
                        },
                        {
                            mr_id: "1694394925",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 7758,
                            under_review_duration_sec: 78705,
                            approval_to_merge_duration_sec: 518749,
                        },
                        {
                            mr_id: "1702570981",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1829,
                            under_review_duration_sec: 22028,
                            approval_to_merge_duration_sec: 240277,
                        },
                        {
                            mr_id: "1696260331",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 347469,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 83530,
                        },
                    ],
                    in_progress_duration_avg: 89414,
                    in_progress_duration_median: 239,
                    in_progress_duration_10th: 32,
                    in_progress_duration_25th: 127,
                    in_progress_duration_75th: 2090,
                    in_progress_duration_90th: 293289,
                    in_progress_duration_95th: 544526,
                    in_progress_duration_99th: 1097898,
                    in_progress_duration_adj_avg: 6685,
                    under_review_duration_avg: 14848,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 10920,
                    under_review_duration_90th: 61265,
                    under_review_duration_95th: 74008,
                    under_review_duration_99th: 76159,
                    under_review_duration_adj_avg: 6744,
                    approved_to_merge_duration_avg: 174473,
                    approved_to_merge_duration_median: 5998,
                    approved_to_merge_duration_10th: 125,
                    approved_to_merge_duration_25th: 556,
                    approved_to_merge_duration_75th: 330678,
                    approved_to_merge_duration_90th: 644295,
                    approved_to_merge_duration_95th: 679709,
                    approved_to_merge_duration_99th: 754125,
                    approved_to_merge_duration_adj_avg: 121990,
                },
                {
                    week: "2024-02-05 00:00:00",
                    mrs: [
                        {
                            mr_id: "1718540531",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 80148,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 85432,
                        },
                        {
                            mr_id: "1718190711",
                            hostname_repo_full_name: "https://api.github.com:perkyguy/website",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 9,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1712480735",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 247664,
                            under_review_duration_sec: 72884,
                            approval_to_merge_duration_sec: 200729,
                        },
                        {
                            mr_id: "1712434218",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 74,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 123,
                        },
                        {
                            mr_id: "1718531066",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 139,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1718301529",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 919,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 742,
                        },
                        {
                            mr_id: "1694611269",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 531266,
                            under_review_duration_sec: 144297,
                            approval_to_merge_duration_sec: 1070634,
                        },
                        {
                            mr_id: "1718631277",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 80311,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 85290,
                        },
                        {
                            mr_id: "1712321989",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4456,
                        },
                        {
                            mr_id: "1712250553",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 33,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 451,
                        },
                        {
                            mr_id: "1712301968",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 380,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 167,
                        },
                        {
                            mr_id: "1718033244",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2258,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 197,
                        },
                        {
                            mr_id: "1716656294",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 49370,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 23794,
                        },
                        {
                            mr_id: "1716047180",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 15,
                        },
                        {
                            mr_id: "1712708286",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 39,
                            under_review_duration_sec: 313,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1712355500",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4505,
                            under_review_duration_sec: 9025,
                            approval_to_merge_duration_sec: 64428,
                        },
                        {
                            mr_id: "1712337851",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4967,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4583,
                        },
                        {
                            mr_id: "1712196123",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 378,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 7,
                        },
                        {
                            mr_id: "1716173399",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 401,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 140,
                        },
                        {
                            mr_id: "1712541705",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2676,
                            under_review_duration_sec: 66873,
                            approval_to_merge_duration_sec: 2185,
                        },
                        {
                            mr_id: "1707314912",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 175,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 332323,
                        },
                        {
                            mr_id: "1715697374",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 61416,
                            under_review_duration_sec: 19534,
                            approval_to_merge_duration_sec: 80635,
                        },
                        {
                            mr_id: "1706731321",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 8830,
                            under_review_duration_sec: 72748,
                            approval_to_merge_duration_sec: 263394,
                        },
                        {
                            mr_id: "1712714429",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 111,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 105,
                        },
                        {
                            mr_id: "1714103580",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 979,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 394,
                        },
                        {
                            mr_id: "1716414846",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 21116,
                            under_review_duration_sec: 73433,
                            approval_to_merge_duration_sec: 1038,
                        },
                        {
                            mr_id: "1718277767",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 24,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 132,
                        },
                        {
                            mr_id: "1718290536",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 174,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 477,
                        },
                        {
                            mr_id: "1712221743",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 101,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 108,
                        },
                        {
                            mr_id: "1714244660",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 78,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1093,
                        },
                        {
                            mr_id: "1718527316",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 90,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 177,
                        },
                        {
                            mr_id: "1718537083",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 254,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 103,
                        },
                        {
                            mr_id: "1705003582",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 456893,
                            under_review_duration_sec: 76433,
                            approval_to_merge_duration_sec: 515295,
                        },
                        {
                            mr_id: "1717948422",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1058,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 76,
                        },
                        {
                            mr_id: "1716283745",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 6612,
                            under_review_duration_sec: 76033,
                            approval_to_merge_duration_sec: 6117,
                        },
                        {
                            mr_id: "1716140207",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4602,
                            under_review_duration_sec: 6962,
                            approval_to_merge_duration_sec: 1061,
                        },
                        {
                            mr_id: "1716109867",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 309,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1594,
                        },
                        {
                            mr_id: "1715995624",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 940,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 6841,
                        },
                        {
                            mr_id: "1714135398",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 330,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2254,
                        },
                        {
                            mr_id: "1707345955",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2090,
                            under_review_duration_sec: 58423,
                            approval_to_merge_duration_sec: 260918,
                        },
                        {
                            mr_id: "1714248994",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 525694,
                            under_review_duration_sec: 25578,
                            approval_to_merge_duration_sec: 236856,
                        },
                        {
                            mr_id: "1718045836",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 42,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 116,
                        },
                        {
                            mr_id: "1716295335",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 16320,
                            under_review_duration_sec: 8,
                            approval_to_merge_duration_sec: 786,
                        },
                        {
                            mr_id: "1716169135",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 168,
                        },
                        {
                            mr_id: "1696100688",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 79202,
                            under_review_duration_sec: 501,
                            approval_to_merge_duration_sec: 959505,
                        },
                        {
                            mr_id: "1712596789",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 606106,
                            under_review_duration_sec: 64568,
                            approval_to_merge_duration_sec: 180376,
                        },
                        {
                            mr_id: "1714551860",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 429154,
                            under_review_duration_sec: 157240,
                            approval_to_merge_duration_sec: 17299,
                        },
                        {
                            mr_id: "1718233535",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 106,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1220,
                        },
                        {
                            mr_id: "1717909276",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1160,
                            under_review_duration_sec: 1737,
                            approval_to_merge_duration_sec: 12282,
                        },
                        {
                            mr_id: "1716234440",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 260,
                            under_review_duration_sec: 917,
                            approval_to_merge_duration_sec: 6753,
                        },
                        {
                            mr_id: "1716048911",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 279,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 7732,
                        },
                        {
                            mr_id: "1714458975",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 69051,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 747,
                        },
                        {
                            mr_id: "1687343656",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 252863,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1216668,
                        },
                        {
                            mr_id: "1718481712",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 5282,
                            under_review_duration_sec: 70162,
                            approval_to_merge_duration_sec: 14161,
                        },
                        {
                            mr_id: "1714199754",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 64226,
                            under_review_duration_sec: 14,
                            approval_to_merge_duration_sec: 528,
                        },
                        {
                            mr_id: "1709428382",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 459,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 240638,
                        },
                        {
                            mr_id: "1709394729",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 909,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 248211,
                        },
                        {
                            mr_id: "1716152566",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 351,
                        },
                        {
                            mr_id: "1707199072",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1085,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 411693,
                        },
                        {
                            mr_id: "1714236078",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 80,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 195,
                        },
                        {
                            mr_id: "1714150215",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 56,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 387,
                        },
                        {
                            mr_id: "1716402595",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 8501,
                            under_review_duration_sec: 354,
                            approval_to_merge_duration_sec: 152881,
                        },
                        {
                            mr_id: "1714147550",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 246,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 766,
                        },
                        {
                            mr_id: "1712448919",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 37,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 291,
                        },
                        {
                            mr_id: "1718367462",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 204,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 8591,
                        },
                    ],
                    in_progress_duration_avg: 63144,
                    in_progress_duration_median: 401,
                    in_progress_duration_10th: 32,
                    in_progress_duration_25th: 85,
                    in_progress_duration_75th: 12410,
                    in_progress_duration_90th: 169599,
                    in_progress_duration_95th: 490722,
                    in_progress_duration_99th: 682755,
                    in_progress_duration_adj_avg: 13644,
                    under_review_duration_avg: 16862,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 1327,
                    under_review_duration_90th: 67531,
                    under_review_duration_95th: 73693,
                    under_review_duration_99th: 230137,
                    under_review_duration_adj_avg: 4044,
                    approved_to_merge_duration_avg: 103642,
                    approved_to_merge_duration_median: 1220,
                    approved_to_merge_duration_10th: 104,
                    approved_to_merge_duration_25th: 195,
                    approved_to_merge_duration_75th: 80635,
                    approved_to_merge_duration_90th: 262404,
                    approved_to_merge_duration_95th: 494575,
                    approved_to_merge_duration_99th: 1123206,
                    approved_to_merge_duration_adj_avg: 38569,
                },
                {
                    week: "2024-02-12 00:00:00",
                    mrs: [
                        {
                            mr_id: "1726418403",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 68,
                        },
                        {
                            mr_id: "1720017088",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 243268,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 174765,
                        },
                        {
                            mr_id: "1724547642",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 204,
                            under_review_duration_sec: 1652,
                            approval_to_merge_duration_sec: 72701,
                        },
                        {
                            mr_id: "1726335745",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 406,
                            under_review_duration_sec: 74185,
                            approval_to_merge_duration_sec: 4211,
                        },
                        {
                            mr_id: "1724673781",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 71371,
                        },
                        {
                            mr_id: "1724581609",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 59,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 75341,
                        },
                        {
                            mr_id: "1724344357",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 164,
                            under_review_duration_sec: 42,
                            approval_to_merge_duration_sec: 2384,
                        },
                        {
                            mr_id: "1719931640",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 676,
                            under_review_duration_sec: 330015,
                            approval_to_merge_duration_sec: 21755,
                        },
                        {
                            mr_id: "1719759176",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 150083,
                            under_review_duration_sec: 5809,
                            approval_to_merge_duration_sec: 410037,
                        },
                        {
                            mr_id: "1709084511",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1296450,
                            under_review_duration_sec: 330804,
                            approval_to_merge_duration_sec: 547909,
                        },
                        {
                            mr_id: "1716681772",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 486836,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 528454,
                        },
                        {
                            mr_id: "1724791248",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 22659,
                            under_review_duration_sec: 49921,
                            approval_to_merge_duration_sec: 8278,
                        },
                        {
                            mr_id: "1726104479",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 221,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 437,
                        },
                        {
                            mr_id: "1726056585",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 369,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 327,
                        },
                        {
                            mr_id: "1725847669",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 39,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 415,
                        },
                        {
                            mr_id: "1725803753",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 33,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 356,
                        },
                        {
                            mr_id: "1726372044",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 38,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 97,
                        },
                        {
                            mr_id: "1726389995",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 56,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 69,
                        },
                        {
                            mr_id: "1728092055",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 30,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 133,
                        },
                        {
                            mr_id: "1719911362",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 788603,
                            under_review_duration_sec: 12484,
                            approval_to_merge_duration_sec: 354912,
                        },
                        {
                            mr_id: "1722701356",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 850742,
                            under_review_duration_sec: 166786,
                            approval_to_merge_duration_sec: 79319,
                        },
                        {
                            mr_id: "1718423076",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 341218,
                            under_review_duration_sec: 961,
                            approval_to_merge_duration_sec: 630,
                        },
                        {
                            mr_id: "1728142670",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 78,
                        },
                        {
                            mr_id: "1725988335",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 64,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 373,
                        },
                        {
                            mr_id: "1730332098",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 156,
                            under_review_duration_sec: 100,
                            approval_to_merge_duration_sec: 268,
                        },
                        {
                            mr_id: "1730274786",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 79,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 959,
                        },
                        {
                            mr_id: "1724441011",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 170,
                            under_review_duration_sec: 163823,
                            approval_to_merge_duration_sec: 3299,
                        },
                        {
                            mr_id: "1722805334",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 152,
                            under_review_duration_sec: 57263,
                            approval_to_merge_duration_sec: 7113,
                        },
                        {
                            mr_id: "1724665245",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 175,
                            under_review_duration_sec: 152206,
                            approval_to_merge_duration_sec: 3625,
                        },
                        {
                            mr_id: "1722848890",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 326,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2384,
                        },
                        {
                            mr_id: "1726329062",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 50,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 970,
                        },
                        {
                            mr_id: "1728172040",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 77,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 63,
                        },
                    ],
                    in_progress_duration_avg: 165680,
                    in_progress_duration_median: 204,
                    in_progress_duration_10th: 34,
                    in_progress_duration_25th: 59,
                    in_progress_duration_75th: 22659,
                    in_progress_duration_90th: 852954,
                    in_progress_duration_95th: 1020469,
                    in_progress_duration_99th: 1142168,
                    in_progress_duration_adj_avg: 69614,
                    under_review_duration_avg: 45140,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 53592,
                    under_review_duration_90th: 163823,
                    under_review_duration_95th: 248400,
                    under_review_duration_99th: 334382,
                    under_review_duration_adj_avg: 20225,
                    approved_to_merge_duration_avg: 74159,
                    approved_to_merge_duration_median: 2384,
                    approved_to_merge_duration_10th: 80,
                    approved_to_merge_duration_25th: 349,
                    approved_to_merge_duration_75th: 71704,
                    approved_to_merge_duration_90th: 336897,
                    approved_to_merge_duration_95th: 463325,
                    approved_to_merge_duration_99th: 541878,
                    approved_to_merge_duration_adj_avg: 22146,
                },
                {
                    week: "2024-02-19 00:00:00",
                    mrs: [
                        {
                            mr_id: "1728620021",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 86772,
                            under_review_duration_sec: 329143,
                            approval_to_merge_duration_sec: 13017,
                        },
                        {
                            mr_id: "1722813572",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 856272,
                            under_review_duration_sec: 336254,
                            approval_to_merge_duration_sec: 616345,
                        },
                        {
                            mr_id: "1728255515",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 642,
                            under_review_duration_sec: 359615,
                            approval_to_merge_duration_sec: 77588,
                        },
                        {
                            mr_id: "1735443145",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 232,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3265,
                        },
                        {
                            mr_id: "1737943747",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1664,
                            under_review_duration_sec: 51471,
                            approval_to_merge_duration_sec: 106042,
                        },
                        {
                            mr_id: "1728298153",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1622,
                            under_review_duration_sec: 699692,
                            approval_to_merge_duration_sec: 3344,
                        },
                        {
                            mr_id: "1722915987",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1788,
                            under_review_duration_sec: 65761,
                            approval_to_merge_duration_sec: 538257,
                        },
                        {
                            mr_id: "1739524073",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 40,
                            under_review_duration_sec: 1871,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1739562587",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2518179,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1414,
                        },
                        {
                            mr_id: "1724491572",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 533043,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 66416,
                        },
                        {
                            mr_id: "1728481376",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 416756,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 107896,
                        },
                        {
                            mr_id: "1728515223",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 466856,
                            under_review_duration_sec: 437280,
                            approval_to_merge_duration_sec: 85526,
                        },
                        {
                            mr_id: "1737652727",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 8258,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 64975,
                        },
                        {
                            mr_id: "1739766534",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 18583,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 53226,
                        },
                        {
                            mr_id: "1735537170",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 246,
                            under_review_duration_sec: 330,
                            approval_to_merge_duration_sec: 2038,
                        },
                        {
                            mr_id: "1735668748",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 713,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 74095,
                        },
                        {
                            mr_id: "1737310804",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 244,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2616,
                        },
                        {
                            mr_id: "1728513962",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 390,
                            under_review_duration_sec: 382,
                            approval_to_merge_duration_sec: 429106,
                        },
                        {
                            mr_id: "1739346789",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 852,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2154,
                        },
                        {
                            mr_id: "1737206137",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 203,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 5700,
                        },
                        {
                            mr_id: "1737270692",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 59,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 974,
                        },
                        {
                            mr_id: "1737616537",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1504,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3160,
                        },
                        {
                            mr_id: "1739372465",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 526,
                            under_review_duration_sec: 58,
                            approval_to_merge_duration_sec: 621,
                        },
                        {
                            mr_id: "1739446723",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 18445,
                            under_review_duration_sec: 58628,
                            approval_to_merge_duration_sec: 19509,
                        },
                        {
                            mr_id: "1739640983",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 252,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4242,
                        },
                    ],
                    in_progress_duration_avg: 221499,
                    in_progress_duration_median: 1990,
                    in_progress_duration_10th: 144,
                    in_progress_duration_25th: 248,
                    in_progress_duration_75th: 59786,
                    in_progress_duration_90th: 474900,
                    in_progress_duration_95th: 1426734,
                    in_progress_duration_99th: 2319792,
                    in_progress_duration_adj_avg: 49147,
                    under_review_duration_avg: 106729,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 83640,
                    under_review_duration_90th: 390681,
                    under_review_duration_95th: 490224,
                    under_review_duration_99th: 651130,
                    under_review_duration_adj_avg: 51325,
                    approved_to_merge_duration_avg: 91261,
                    approved_to_merge_duration_median: 13017,
                    approved_to_merge_duration_10th: 1150,
                    approved_to_merge_duration_25th: 2616,
                    approved_to_merge_duration_75th: 77588,
                    approved_to_merge_duration_90th: 300622,
                    approved_to_merge_duration_95th: 516427,
                    approved_to_merge_duration_99th: 597604,
                    approved_to_merge_duration_adj_avg: 36643,
                },
                {
                    week: "2024-02-26 00:00:00",
                    mrs: [
                        {
                            mr_id: "1747954594",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 8650,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 104443,
                        },
                        {
                            mr_id: "1744251935",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 32,
                            under_review_duration_sec: 2112,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1744012643",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 59,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 45,
                        },
                        {
                            mr_id: "1744044490",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 397,
                            under_review_duration_sec: 2376,
                            approval_to_merge_duration_sec: 11663,
                        },
                        {
                            mr_id: "1732795654",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 223766,
                            under_review_duration_sec: 108653,
                            approval_to_merge_duration_sec: 780139,
                        },
                        {
                            mr_id: "1744219959",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 532,
                            under_review_duration_sec: 2,
                            approval_to_merge_duration_sec: 553,
                        },
                        {
                            mr_id: "1744472957",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 168,
                            under_review_duration_sec: 533,
                            approval_to_merge_duration_sec: 321743,
                        },
                        {
                            mr_id: "1741455818",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2316,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 433120,
                        },
                        {
                            mr_id: "1744022140",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1094,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3158,
                        },
                        {
                            mr_id: "1741171480",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 85,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 255915,
                        },
                        {
                            mr_id: "1741225370",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 243777,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 9932,
                        },
                        {
                            mr_id: "1744174917",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2106,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2634,
                        },
                        {
                            mr_id: "1750221475",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 282,
                            under_review_duration_sec: 1722,
                            approval_to_merge_duration_sec: 5742,
                        },
                        {
                            mr_id: "1748249345",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 99285,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4004,
                        },
                        {
                            mr_id: "1739294539",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 13538,
                            under_review_duration_sec: 354576,
                            approval_to_merge_duration_sec: 175735,
                        },
                        {
                            mr_id: "1746160454",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 258,
                            under_review_duration_sec: 427,
                            approval_to_merge_duration_sec: 186,
                        },
                        {
                            mr_id: "1726237282",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1015901,
                            under_review_duration_sec: 512915,
                            approval_to_merge_duration_sec: 699549,
                        },
                        {
                            mr_id: "1696422875",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2,
                            under_review_duration_sec: 2743150,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1746515571",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2239,
                            under_review_duration_sec: 2127,
                            approval_to_merge_duration_sec: 67130,
                        },
                        {
                            mr_id: "1744294934",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 548,
                            under_review_duration_sec: 792,
                            approval_to_merge_duration_sec: 2151,
                        },
                        {
                            mr_id: "1750343288",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 620,
                            under_review_duration_sec: 550,
                            approval_to_merge_duration_sec: 4206,
                        },
                        {
                            mr_id: "1743956696",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 59,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1440,
                        },
                        {
                            mr_id: "1748525333",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3211,
                            under_review_duration_sec: 3764,
                            approval_to_merge_duration_sec: 65258,
                        },
                        {
                            mr_id: "1747994838",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 63447,
                            under_review_duration_sec: 1,
                            approval_to_merge_duration_sec: 84080,
                        },
                        {
                            mr_id: "1743784766",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 417158,
                            under_review_duration_sec: 7249,
                            approval_to_merge_duration_sec: 270279,
                        },
                        {
                            mr_id: "1748403950",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 6281,
                            under_review_duration_sec: 7,
                            approval_to_merge_duration_sec: 83514,
                        },
                        {
                            mr_id: "1744448830",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 38,
                            under_review_duration_sec: 78,
                            approval_to_merge_duration_sec: 78431,
                        },
                    ],
                    in_progress_duration_avg: 112323,
                    in_progress_duration_median: 2005,
                    in_progress_duration_10th: 59,
                    in_progress_duration_25th: 311,
                    in_progress_duration_75th: 49656,
                    in_progress_duration_90th: 200429,
                    in_progress_duration_95th: 447187,
                    in_progress_duration_99th: 1654899,
                    in_progress_duration_adj_avg: 16028,
                    under_review_duration_avg: 188982,
                    under_review_duration_median: 1033,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 1,
                    under_review_duration_75th: 163536,
                    under_review_duration_90th: 352921,
                    under_review_duration_95th: 841934,
                    under_review_duration_99th: 2295404,
                    under_review_duration_adj_avg: 44395,
                    approved_to_merge_duration_avg: 128335,
                    approved_to_merge_duration_median: 11663,
                    approved_to_merge_duration_10th: 130,
                    approved_to_merge_duration_25th: 2392,
                    approved_to_merge_duration_75th: 140089,
                    approved_to_merge_duration_90th: 366294,
                    approved_to_merge_duration_95th: 619620,
                    approved_to_merge_duration_99th: 759186,
                    approved_to_merge_duration_adj_avg: 73914,
                },
                {
                    week: "2024-03-04 00:00:00",
                    mrs: [
                        {
                            mr_id: "1755389776",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4862,
                            under_review_duration_sec: 10467,
                            approval_to_merge_duration_sec: 156080,
                        },
                        {
                            mr_id: "1733740634",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 177899,
                            under_review_duration_sec: 507261,
                            approval_to_merge_duration_sec: 687547,
                        },
                        {
                            mr_id: "1750636057",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 63325,
                            under_review_duration_sec: 270268,
                            approval_to_merge_duration_sec: 5960,
                        },
                        {
                            mr_id: "1757771842",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 276,
                            under_review_duration_sec: 745,
                            approval_to_merge_duration_sec: 167,
                        },
                        {
                            mr_id: "1759152243",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 589,
                            under_review_duration_sec: 394,
                            approval_to_merge_duration_sec: 91,
                        },
                        {
                            mr_id: "1761632199",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 107,
                            under_review_duration_sec: 235,
                            approval_to_merge_duration_sec: 79614,
                        },
                        {
                            mr_id: "1761798267",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 650,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 72533,
                        },
                        {
                            mr_id: "1761940460",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 68,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 340,
                        },
                        {
                            mr_id: "1761647730",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 333,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 970,
                        },
                        {
                            mr_id: "1761193447",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 736,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 85,
                        },
                        {
                            mr_id: "1761715884",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 185,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 338,
                        },
                        {
                            mr_id: "1730372349",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1200345,
                            under_review_duration_sec: 322027,
                            approval_to_merge_duration_sec: 1318417,
                        },
                        {
                            mr_id: "1763509034",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 248,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 236,
                        },
                        {
                            mr_id: "1759709278",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1943,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1663,
                        },
                        {
                            mr_id: "1757869312",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 263,
                            under_review_duration_sec: 396,
                            approval_to_merge_duration_sec: 6,
                        },
                        {
                            mr_id: "1755717775",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1035,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1338,
                        },
                        {
                            mr_id: "1755365379",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 192,
                            under_review_duration_sec: 977,
                            approval_to_merge_duration_sec: 2901,
                        },
                        {
                            mr_id: "1755124747",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 565,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 83,
                        },
                        {
                            mr_id: "1763449275",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1178,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 666,
                        },
                        {
                            mr_id: "1763365445",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1017,
                            under_review_duration_sec: 4106,
                            approval_to_merge_duration_sec: 414,
                        },
                        {
                            mr_id: "1763553205",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2961,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3860,
                        },
                        {
                            mr_id: "1761712892",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 70,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 76475,
                        },
                        {
                            mr_id: "1761534042",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1136,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1633,
                        },
                        {
                            mr_id: "1746240490",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 502954,
                            under_review_duration_sec: 243706,
                            approval_to_merge_duration_sec: 268918,
                        },
                        {
                            mr_id: "1759556054",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3288,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 712,
                        },
                        {
                            mr_id: "1761754152",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 32,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 62,
                        },
                        {
                            mr_id: "1761737038",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 44,
                            under_review_duration_sec: 4,
                            approval_to_merge_duration_sec: 220,
                        },
                        {
                            mr_id: "1761608026",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 63,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 425,
                        },
                        {
                            mr_id: "1757584002",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 383,
                            under_review_duration_sec: 1679,
                            approval_to_merge_duration_sec: 88,
                        },
                        {
                            mr_id: "1752480353",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 91012,
                            under_review_duration_sec: 430847,
                            approval_to_merge_duration_sec: 65803,
                        },
                        {
                            mr_id: "1746425443",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 86,
                            under_review_duration_sec: 1033,
                            approval_to_merge_duration_sec: 768657,
                        },
                        {
                            mr_id: "1739868965",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1724631,
                            under_review_duration_sec: 1008009,
                            approval_to_merge_duration_sec: 118261,
                        },
                        {
                            mr_id: "1757572252",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 12648,
                            under_review_duration_sec: 116,
                            approval_to_merge_duration_sec: 23551,
                        },
                        {
                            mr_id: "1756116583",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 386,
                            under_review_duration_sec: 31363,
                            approval_to_merge_duration_sec: 113541,
                        },
                        {
                            mr_id: "1747941004",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 7611,
                            under_review_duration_sec: 179705,
                            approval_to_merge_duration_sec: 435856,
                        },
                        {
                            mr_id: "1761364298",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 63,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 251,
                        },
                        {
                            mr_id: "1748217910",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2222275,
                            under_review_duration_sec: 163536,
                            approval_to_merge_duration_sec: 530002,
                        },
                        {
                            mr_id: "1726696927",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1038743,
                            under_review_duration_sec: 1343944,
                            approval_to_merge_duration_sec: 448033,
                        },
                        {
                            mr_id: "1752556692",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1904,
                            under_review_duration_sec: 317797,
                            approval_to_merge_duration_sec: 103755,
                        },
                        {
                            mr_id: "1741500063",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25834,
                            under_review_duration_sec: 346301,
                            approval_to_merge_duration_sec: 677086,
                        },
                        {
                            mr_id: "1757937481",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 842,
                            under_review_duration_sec: 52180,
                            approval_to_merge_duration_sec: 11132,
                        },
                        {
                            mr_id: "1755718150",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 170,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 894,
                        },
                        {
                            mr_id: "1761788040",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 37,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 76,
                        },
                        {
                            mr_id: "1759712266",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1832,
                            under_review_duration_sec: 91812,
                            approval_to_merge_duration_sec: 83579,
                        },
                        {
                            mr_id: "1761955370",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 166,
                        },
                        {
                            mr_id: "1757183920",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1620,
                            under_review_duration_sec: 1058,
                            approval_to_merge_duration_sec: 679,
                        },
                        {
                            mr_id: "1761424772",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1250,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 462,
                        },
                        {
                            mr_id: "1744420071",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 658,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 574230,
                        },
                        {
                            mr_id: "1752479539",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2661,
                            under_review_duration_sec: 240047,
                            approval_to_merge_duration_sec: 174659,
                        },
                        {
                            mr_id: "1752189035",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 71695,
                            under_review_duration_sec: 261874,
                            approval_to_merge_duration_sec: 96215,
                        },
                    ],
                    in_progress_duration_avg: 119442,
                    in_progress_duration_median: 650,
                    in_progress_duration_10th: 55,
                    in_progress_duration_25th: 185,
                    in_progress_duration_75th: 1943,
                    in_progress_duration_90th: 66237,
                    in_progress_duration_95th: 831127,
                    in_progress_duration_99th: 1953606,
                    in_progress_duration_adj_avg: 1959,
                    under_review_duration_avg: 64866,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 3499,
                    under_review_duration_90th: 259691,
                    under_review_duration_95th: 315421,
                    under_review_duration_99th: 771373,
                    under_review_duration_adj_avg: 11772,
                    approved_to_merge_duration_avg: 138175,
                    approved_to_merge_duration_median: 2282,
                    approved_to_merge_duration_10th: 88,
                    approved_to_merge_duration_25th: 338,
                    approved_to_merge_duration_75th: 111094,
                    approved_to_merge_duration_90th: 534425,
                    approved_to_merge_duration_95th: 682840,
                    approved_to_merge_duration_99th: 1049035,
                    approved_to_merge_duration_adj_avg: 72062,
                },
                {
                    week: "2024-03-11 00:00:00",
                    mrs: [
                        {
                            mr_id: "1768305053",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 371,
                            under_review_duration_sec: 170322,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1763716955",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 311,
                            under_review_duration_sec: 226422,
                            approval_to_merge_duration_sec: 23448,
                        },
                        {
                            mr_id: "1766209021",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1082,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 56,
                        },
                        {
                            mr_id: "1772606300",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 394,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 22,
                        },
                        {
                            mr_id: "1744211773",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3961,
                            under_review_duration_sec: 324499,
                            approval_to_merge_duration_sec: 1053597,
                        },
                        {
                            mr_id: "1767973887",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 56,
                            under_review_duration_sec: 79,
                            approval_to_merge_duration_sec: 862,
                        },
                        {
                            mr_id: "1766568076",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 52,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2880,
                        },
                        {
                            mr_id: "1766122735",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 30,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 265,
                        },
                        {
                            mr_id: "1766550907",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 118,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 309,
                        },
                        {
                            mr_id: "1761539350",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 21352,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 666083,
                        },
                        {
                            mr_id: "1770564719",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 33,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 359,
                        },
                        {
                            mr_id: "1763756118",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 227789,
                            under_review_duration_sec: 9663,
                            approval_to_merge_duration_sec: 9730,
                        },
                        {
                            mr_id: "1770495153",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 150,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2178,
                        },
                        {
                            mr_id: "1766168863",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4769,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 169764,
                        },
                        {
                            mr_id: "1763743301",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 50,
                            under_review_duration_sec: 494223,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1761563473",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4643,
                            under_review_duration_sec: 342450,
                            approval_to_merge_duration_sec: 8954,
                        },
                        {
                            mr_id: "1772665318",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 247,
                        },
                        {
                            mr_id: "1763756375",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 224172,
                            under_review_duration_sec: 8,
                            approval_to_merge_duration_sec: 25454,
                        },
                        {
                            mr_id: "1755979000",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 635507,
                            under_review_duration_sec: 753422,
                            approval_to_merge_duration_sec: 11301,
                        },
                        {
                            mr_id: "1766042442",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2153,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 55,
                        },
                        {
                            mr_id: "1770517622",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 109,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 462,
                        },
                        {
                            mr_id: "1766674883",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 36,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 997,
                        },
                        {
                            mr_id: "1763532086",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 96161,
                            under_review_duration_sec: 272727,
                            approval_to_merge_duration_sec: 74913,
                        },
                        {
                            mr_id: "1766714670",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 347,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 243549,
                        },
                        {
                            mr_id: "1772969372",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 182,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 181,
                        },
                    ],
                    in_progress_duration_avg: 122581,
                    in_progress_duration_median: 394,
                    in_progress_duration_10th: 35,
                    in_progress_duration_25th: 114,
                    in_progress_duration_75th: 75433,
                    in_progress_duration_90th: 245819,
                    in_progress_duration_95th: 674342,
                    in_progress_duration_99th: 1248761,
                    in_progress_duration_adj_avg: 38104,
                    under_review_duration_avg: 144359,
                    under_review_duration_median: 4,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 212397,
                    under_review_duration_90th: 522834,
                    under_review_duration_95th: 680154,
                    under_review_duration_99th: 782090,
                    under_review_duration_adj_avg: 81220,
                    approved_to_merge_duration_avg: 91827,
                    approved_to_merge_duration_median: 997,
                    approved_to_merge_duration_10th: 35,
                    approved_to_merge_duration_25th: 247,
                    approved_to_merge_duration_75th: 23448,
                    approved_to_merge_duration_90th: 214035,
                    approved_to_merge_duration_95th: 581576,
                    approved_to_merge_duration_99th: 960594,
                    approved_to_merge_duration_adj_avg: 17496,
                },
                {
                    week: "2024-03-18 00:00:00",
                    mrs: [
                        {
                            mr_id: "1782171861",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 251,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3243,
                        },
                        {
                            mr_id: "1784727849",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 62,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 15535,
                        },
                        {
                            mr_id: "1780453707",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 226,
                        },
                        {
                            mr_id: "1786538622",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 473,
                        },
                        {
                            mr_id: "1782804875",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 23,
                            under_review_duration_sec: 7,
                            approval_to_merge_duration_sec: 4326,
                        },
                        {
                            mr_id: "1780656551",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 230,
                        },
                        {
                            mr_id: "1779941981",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 107,
                            under_review_duration_sec: 106,
                            approval_to_merge_duration_sec: 271,
                        },
                        {
                            mr_id: "1766827461",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 63400,
                            under_review_duration_sec: 622448,
                            approval_to_merge_duration_sec: 181337,
                        },
                        {
                            mr_id: "1765938510",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 272863,
                            under_review_duration_sec: 75,
                            approval_to_merge_duration_sec: 604246,
                        },
                        {
                            mr_id: "1780762213",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 37,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 217,
                        },
                        {
                            mr_id: "1782937943",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 215,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 391,
                        },
                        {
                            mr_id: "1785225522",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 15,
                            under_review_duration_sec: 7,
                            approval_to_merge_duration_sec: 355,
                        },
                        {
                            mr_id: "1768813131",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 87466,
                            under_review_duration_sec: 160873,
                            approval_to_merge_duration_sec: 338372,
                        },
                        {
                            mr_id: "1750529565",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 610,
                            under_review_duration_sec: 6946,
                            approval_to_merge_duration_sec: 1614579,
                        },
                        {
                            mr_id: "1752512276",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2733730,
                            under_review_duration_sec: 793800,
                            approval_to_merge_duration_sec: 339075,
                        },
                        {
                            mr_id: "1762173876",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 846405,
                            under_review_duration_sec: 433904,
                            approval_to_merge_duration_sec: 213284,
                        },
                        {
                            mr_id: "1763623503",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1390130,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 416487,
                        },
                        {
                            mr_id: "1763724685",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 960721,
                            under_review_duration_sec: 590605,
                            approval_to_merge_duration_sec: 460306,
                        },
                        {
                            mr_id: "1773051391",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 16319,
                            under_review_duration_sec: 805,
                            approval_to_merge_duration_sec: 495188,
                        },
                        {
                            mr_id: "1786721883",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 277,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 283,
                        },
                        {
                            mr_id: "1780851854",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 204,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 65636,
                        },
                        {
                            mr_id: "1780578725",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 175,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2218,
                        },
                        {
                            mr_id: "1769013349",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 703069,
                            under_review_duration_sec: 70689,
                            approval_to_merge_duration_sec: 128929,
                        },
                        {
                            mr_id: "1780711579",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 625,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 711,
                        },
                        {
                            mr_id: "1784570861",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 409,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3805,
                        },
                        {
                            mr_id: "1785191336",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 355,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 885,
                        },
                        {
                            mr_id: "1772108499",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 166657,
                            under_review_duration_sec: 541733,
                            approval_to_merge_duration_sec: 85328,
                        },
                        {
                            mr_id: "1763816095",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1305,
                            under_review_duration_sec: 937348,
                            approval_to_merge_duration_sec: 252000,
                        },
                        {
                            mr_id: "1783076055",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 22,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 254,
                        },
                        {
                            mr_id: "1782906891",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 342,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 642,
                        },
                        {
                            mr_id: "1780430594",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 82,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 542,
                        },
                        {
                            mr_id: "1766810932",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4388,
                            under_review_duration_sec: 687033,
                            approval_to_merge_duration_sec: 122411,
                        },
                        {
                            mr_id: "1762084587",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 880032,
                            under_review_duration_sec: 515304,
                            approval_to_merge_duration_sec: 411234,
                        },
                        {
                            mr_id: "1773009664",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 183,
                            under_review_duration_sec: 349691,
                            approval_to_merge_duration_sec: 26,
                        },
                        {
                            mr_id: "1782521207",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1863,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 6443,
                        },
                        {
                            mr_id: "1785379428",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1104,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 57521,
                        },
                    ],
                    in_progress_duration_avg: 180297,
                    in_progress_duration_median: 277,
                    in_progress_duration_10th: 26,
                    in_progress_duration_25th: 50,
                    in_progress_duration_75th: 3682,
                    in_progress_duration_90th: 520708,
                    in_progress_duration_95th: 666105,
                    in_progress_duration_99th: 2335601,
                    in_progress_duration_adj_avg: 48867,
                    under_review_duration_avg: 113455,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 76085,
                    under_review_duration_90th: 477036,
                    under_review_duration_95th: 635365,
                    under_review_duration_99th: 847235,
                    under_review_duration_adj_avg: 42706,
                    approved_to_merge_duration_avg: 161861,
                    approved_to_merge_duration_median: 5384,
                    approved_to_merge_duration_10th: 242,
                    approved_to_merge_duration_25th: 452,
                    approved_to_merge_duration_75th: 222963,
                    approved_to_merge_duration_90th: 438397,
                    approved_to_merge_duration_95th: 522452,
                    approved_to_merge_duration_99th: 1260962,
                    approved_to_merge_duration_adj_avg: 94714,
                },
                {
                    week: "2024-03-25 00:00:00",
                    mrs: [
                        {
                            mr_id: "1777665665",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 252419,
                            under_review_duration_sec: 2885,
                            approval_to_merge_duration_sec: 857236,
                        },
                        {
                            mr_id: "1782951061",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3035258,
                            under_review_duration_sec: 7844,
                            approval_to_merge_duration_sec: 688900,
                        },
                        {
                            mr_id: "1790679981",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 96,
                            under_review_duration_sec: 28,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1778847224",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1033,
                            under_review_duration_sec: 231029,
                            approval_to_merge_duration_sec: 429602,
                        },
                        {
                            mr_id: "1773047127",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 629142,
                            under_review_duration_sec: 52991,
                            approval_to_merge_duration_sec: 419993,
                        },
                        {
                            mr_id: "1785011579",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 5500,
                            under_review_duration_sec: 76085,
                            approval_to_merge_duration_sec: 340028,
                        },
                        {
                            mr_id: "1785038341",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 520708,
                            under_review_duration_sec: 91875,
                            approval_to_merge_duration_sec: 416333,
                        },
                        {
                            mr_id: "1782462414",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 429466,
                            under_review_duration_sec: 92175,
                            approval_to_merge_duration_sec: 421727,
                        },
                        {
                            mr_id: "1786747160",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 345236,
                        },
                        {
                            mr_id: "1790684603",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 173,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 247,
                        },
                    ],
                    in_progress_duration_avg: 138577,
                    in_progress_duration_median: 2226,
                    in_progress_duration_10th: 134,
                    in_progress_duration_25th: 288,
                    in_progress_duration_75th: 120973,
                    in_progress_duration_90th: 413372,
                    in_progress_duration_95th: 540045,
                    in_progress_duration_99th: 641384,
                    in_progress_duration_adj_avg: 41162,
                    under_review_duration_avg: 6,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 0,
                    under_review_duration_90th: 17,
                    under_review_duration_95th: 22,
                    under_review_duration_99th: 27,
                    under_review_duration_adj_avg: 0,
                    approved_to_merge_duration_avg: 391930,
                    approved_to_merge_duration_median: 418163,
                    approved_to_merge_duration_10th: 222,
                    approved_to_merge_duration_25th: 341330,
                    approved_to_merge_duration_75th: 427633,
                    approved_to_merge_duration_90th: 705734,
                    approved_to_merge_duration_95th: 781485,
                    approved_to_merge_duration_99th: 842086,
                    approved_to_merge_duration_adj_avg: 382758,
                },
                {
                    week: "2024-04-01 00:00:00",
                    mrs: [
                        {
                            mr_id: "1802849536",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 205,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 495,
                        },
                        {
                            mr_id: "1807928608",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 51,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 38,
                        },
                        {
                            mr_id: "1809635779",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 99,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 145,
                        },
                        {
                            mr_id: "1746642605",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2,
                            under_review_duration_sec: 3180506,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1807499356",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 30,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 113,
                        },
                        {
                            mr_id: "1809745176",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 105,
                        },
                        {
                            mr_id: "1787000947",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 6329,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1213176,
                        },
                        {
                            mr_id: "1803362535",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 174,
                            under_review_duration_sec: 247,
                            approval_to_merge_duration_sec: 64018,
                        },
                        {
                            mr_id: "1804879070",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 199,
                            under_review_duration_sec: 1039,
                            approval_to_merge_duration_sec: 2218,
                        },
                        {
                            mr_id: "1804798449",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1938,
                            under_review_duration_sec: 90,
                            approval_to_merge_duration_sec: 15216,
                        },
                        {
                            mr_id: "1802596495",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 6060,
                            under_review_duration_sec: 27514,
                            approval_to_merge_duration_sec: 87089,
                        },
                        {
                            mr_id: "1746237623",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3192282,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 106315,
                        },
                        {
                            mr_id: "1796247898",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 160024,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 346187,
                        },
                        {
                            mr_id: "1787131431",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 666719,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 643860,
                        },
                        {
                            mr_id: "1796716031",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3821,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 351254,
                        },
                        {
                            mr_id: "1809681905",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 82,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 127,
                        },
                        {
                            mr_id: "1807694659",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 3978,
                            approval_to_merge_duration_sec: 165,
                        },
                        {
                            mr_id: "1809654970",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 70,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 106,
                        },
                        {
                            mr_id: "1809662556",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 91,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 63,
                        },
                        {
                            mr_id: "1809588432",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 488,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 11,
                        },
                        {
                            mr_id: "1807800046",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 48,
                        },
                        {
                            mr_id: "1803106523",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1343,
                            under_review_duration_sec: 3527,
                            approval_to_merge_duration_sec: 166368,
                        },
                        {
                            mr_id: "1807881515",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 32,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 89,
                        },
                        {
                            mr_id: "1807299819",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 97,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1005,
                        },
                        {
                            mr_id: "1809646180",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 113,
                        },
                        {
                            mr_id: "1809609112",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1157,
                        },
                        {
                            mr_id: "1807937674",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 67728,
                        },
                        {
                            mr_id: "1807521810",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 78,
                        },
                        {
                            mr_id: "1805346862",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 22,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 187,
                        },
                        {
                            mr_id: "1807569700",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 111,
                        },
                        {
                            mr_id: "1802869656",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 642,
                            under_review_duration_sec: 85344,
                            approval_to_merge_duration_sec: 173056,
                        },
                        {
                            mr_id: "1805235205",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 43,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 529,
                        },
                        {
                            mr_id: "1807610226",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 32,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 84,
                        },
                        {
                            mr_id: "1807807149",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 152,
                        },
                        {
                            mr_id: "1805223442",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 184,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 238,
                        },
                        {
                            mr_id: "1807347018",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 40,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 86,
                        },
                        {
                            mr_id: "1805301189",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 763,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 697,
                        },
                    ],
                    in_progress_duration_avg: 82297,
                    in_progress_duration_median: 179,
                    in_progress_duration_10th: 29,
                    in_progress_duration_25th: 34,
                    in_progress_duration_75th: 683,
                    in_progress_duration_90th: 55413,
                    in_progress_duration_95th: 83330,
                    in_progress_duration_99th: 1888257,
                    in_progress_duration_adj_avg: 1445,
                    under_review_duration_avg: 80334,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 1689,
                    under_review_duration_90th: 20076,
                    under_review_duration_95th: 76669,
                    under_review_duration_99th: 1882036,
                    under_review_duration_adj_avg: 1526,
                    approved_to_merge_duration_avg: 87633,
                    approved_to_merge_duration_median: 187,
                    approved_to_merge_duration_10th: 57,
                    approved_to_merge_duration_25th: 105,
                    approved_to_merge_duration_75th: 64018,
                    approved_to_merge_duration_90th: 242308,
                    approved_to_merge_duration_95th: 409775,
                    approved_to_merge_duration_99th: 1008222,
                    approved_to_merge_duration_adj_avg: 23719,
                },
                {
                    week: "2024-04-08 00:00:00",
                    mrs: [
                        {
                            mr_id: "1812864630",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 108,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 13,
                        },
                        {
                            mr_id: "1801229256",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 369,
                            under_review_duration_sec: 474,
                            approval_to_merge_duration_sec: 926204,
                        },
                        {
                            mr_id: "1814663242",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 37,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 93,
                        },
                        {
                            mr_id: "1816245354",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 47,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 81,
                        },
                        {
                            mr_id: "1812653264",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 124,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 10,
                        },
                        {
                            mr_id: "1818436532",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3292,
                            under_review_duration_sec: 5408,
                            approval_to_merge_duration_sec: 116189,
                        },
                        {
                            mr_id: "1814233233",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 98720,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 106998,
                        },
                        {
                            mr_id: "1809711632",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 383,
                            under_review_duration_sec: 1076,
                            approval_to_merge_duration_sec: 427072,
                        },
                        {
                            mr_id: "1809431130",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 64535,
                            under_review_duration_sec: 8425,
                            approval_to_merge_duration_sec: 267666,
                        },
                        {
                            mr_id: "1807552370",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 67869,
                            under_review_duration_sec: 17858,
                            approval_to_merge_duration_sec: 596806,
                        },
                        {
                            mr_id: "1818732705",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 142,
                        },
                        {
                            mr_id: "1812552288",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 350,
                            under_review_duration_sec: 573,
                            approval_to_merge_duration_sec: 77750,
                        },
                        {
                            mr_id: "1814239886",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 30,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 113,
                        },
                        {
                            mr_id: "1812757908",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 89,
                        },
                        {
                            mr_id: "1816224273",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 73,
                        },
                        {
                            mr_id: "1812868537",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 100,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 125,
                        },
                        {
                            mr_id: "1801052159",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1330,
                            under_review_duration_sec: 3804,
                            approval_to_merge_duration_sec: 852484,
                        },
                        {
                            mr_id: "1820200477",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 437,
                            under_review_duration_sec: 1799,
                            approval_to_merge_duration_sec: 76,
                        },
                        {
                            mr_id: "1805177002",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 159665,
                            under_review_duration_sec: 17300,
                            approval_to_merge_duration_sec: 664878,
                        },
                        {
                            mr_id: "1812665145",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 209,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 122,
                        },
                        {
                            mr_id: "1812579805",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 728,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 193,
                        },
                        {
                            mr_id: "1805725434",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 254,
                            under_review_duration_sec: 620,
                            approval_to_merge_duration_sec: 578733,
                        },
                        {
                            mr_id: "1807764443",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 261,
                            under_review_duration_sec: 953,
                            approval_to_merge_duration_sec: 506597,
                        },
                        {
                            mr_id: "1816823173",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 79643,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 5313,
                        },
                        {
                            mr_id: "1812884537",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 21,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 117,
                        },
                        {
                            mr_id: "1814148696",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2936,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 87,
                        },
                        {
                            mr_id: "1812735024",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 99,
                        },
                        {
                            mr_id: "1814324527",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 30,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 119,
                        },
                        {
                            mr_id: "1805666265",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 656,
                            under_review_duration_sec: 160809,
                            approval_to_merge_duration_sec: 245829,
                        },
                        {
                            mr_id: "1812916458",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 87,
                        },
                        {
                            mr_id: "1812568050",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 48,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 138,
                        },
                        {
                            mr_id: "1816464131",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 135,
                        },
                        {
                            mr_id: "1816408379",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 115,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 588,
                        },
                        {
                            mr_id: "1816525545",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 46,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 84,
                        },
                        {
                            mr_id: "1820513912",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 268,
                            under_review_duration_sec: 2235,
                            approval_to_merge_duration_sec: 2285,
                        },
                        {
                            mr_id: "1816194532",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1750,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 264,
                        },
                        {
                            mr_id: "1812639681",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 701,
                        },
                        {
                            mr_id: "1812443021",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 241,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 735,
                        },
                        {
                            mr_id: "1807570774",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 86059,
                            under_review_duration_sec: 21027,
                            approval_to_merge_duration_sec: 575140,
                        },
                    ],
                    in_progress_duration_avg: 13011,
                    in_progress_duration_median: 124,
                    in_progress_duration_10th: 29,
                    in_progress_duration_25th: 33,
                    in_progress_duration_75th: 1181,
                    in_progress_duration_90th: 45431,
                    in_progress_duration_95th: 85366,
                    in_progress_duration_99th: 154707,
                    in_progress_duration_adj_avg: 920,
                    under_review_duration_avg: 933,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 0,
                    under_review_duration_90th: 2191,
                    under_review_duration_95th: 6301,
                    under_review_duration_99th: 10871,
                    under_review_duration_adj_avg: 85,
                    approved_to_merge_duration_avg: 152673,
                    approved_to_merge_duration_median: 193,
                    approved_to_merge_duration_10th: 80,
                    approved_to_merge_duration_25th: 96,
                    approved_to_merge_duration_75th: 181009,
                    approved_to_merge_duration_90th: 582348,
                    approved_to_merge_duration_95th: 683639,
                    approved_to_merge_duration_99th: 898190,
                    approved_to_merge_duration_adj_avg: 93990,
                },
                {
                    week: "2024-04-15 00:00:00",
                    mrs: [
                        {
                            mr_id: "1824242615",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 17712,
                            under_review_duration_sec: 62524,
                            approval_to_merge_duration_sec: 94558,
                        },
                        {
                            mr_id: "1830006768",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2667,
                            under_review_duration_sec: 1547,
                            approval_to_merge_duration_sec: 91275,
                        },
                        {
                            mr_id: "1816384238",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 12124,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 523802,
                        },
                        {
                            mr_id: "1821012005",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1634,
                            under_review_duration_sec: 429630,
                            approval_to_merge_duration_sec: 157208,
                        },
                        {
                            mr_id: "1829682361",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 98,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1739,
                        },
                        {
                            mr_id: "1824581282",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 241,
                            under_review_duration_sec: 35346,
                            approval_to_merge_duration_sec: 90579,
                        },
                        {
                            mr_id: "1816606659",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 408,
                            under_review_duration_sec: 7393,
                            approval_to_merge_duration_sec: 677678,
                        },
                        {
                            mr_id: "1826098708",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 127,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2588,
                        },
                        {
                            mr_id: "1818403651",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 67635,
                            under_review_duration_sec: 12434,
                            approval_to_merge_duration_sec: 511280,
                        },
                        {
                            mr_id: "1805519875",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1217612,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 77037,
                        },
                    ],
                    in_progress_duration_avg: 113268,
                    in_progress_duration_median: 2667,
                    in_progress_duration_10th: 54,
                    in_progress_duration_25th: 127,
                    in_progress_duration_75th: 17712,
                    in_progress_duration_90th: 152512,
                    in_progress_duration_95th: 594269,
                    in_progress_duration_99th: 1092943,
                    in_progress_duration_adj_avg: 8456,
                    under_review_duration_avg: 1146914,
                    under_review_duration_median: 5542,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 246077,
                    under_review_duration_90th: 5011763,
                    under_review_duration_95th: 6040731,
                    under_review_duration_99th: 6863905,
                    under_review_duration_adj_avg: 554635,
                    approved_to_merge_duration_avg: 222774,
                    approved_to_merge_duration_median: 92916,
                    approved_to_merge_duration_10th: 2503,
                    approved_to_merge_duration_25th: 80422,
                    approved_to_merge_duration_75th: 422762,
                    approved_to_merge_duration_90th: 539190,
                    approved_to_merge_duration_95th: 608434,
                    approved_to_merge_duration_99th: 663829,
                    approved_to_merge_duration_adj_avg: 193541,
                },
                {
                    week: "2024-04-22 00:00:00",
                    mrs: [
                        {
                            mr_id: "1827840760",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 519,
                            under_review_duration_sec: 5542,
                            approval_to_merge_duration_sec: 425528,
                        },
                        {
                            mr_id: "1834759505",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 7709,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 169,
                        },
                        {
                            mr_id: "1841517512",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 71,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2486,
                        },
                        {
                            mr_id: "1839108861",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 92,
                        },
                        {
                            mr_id: "1834490227",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 331484,
                            under_review_duration_sec: 1321,
                            approval_to_merge_duration_sec: 9520,
                        },
                        {
                            mr_id: "1697691800",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1065,
                            under_review_duration_sec: 7069699,
                            approval_to_merge_duration_sec: 434306,
                        },
                        {
                            mr_id: "1843259299",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 4182,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 5843,
                        },
                        {
                            mr_id: "1841268847",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 663,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 42,
                        },
                        {
                            mr_id: "1839045098",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 36,
                            under_review_duration_sec: 60,
                            approval_to_merge_duration_sec: 118,
                        },
                        {
                            mr_id: "1835068156",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 607187,
                            under_review_duration_sec: 10649,
                            approval_to_merge_duration_sec: 72691,
                        },
                        {
                            mr_id: "1841285529",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 30,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 159,
                        },
                        {
                            mr_id: "1838848883",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 67,
                            under_review_duration_sec: 87,
                            approval_to_merge_duration_sec: 5068,
                        },
                        {
                            mr_id: "1827684743",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 47730,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 698237,
                        },
                        {
                            mr_id: "1843384195",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 32,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 76,
                        },
                        {
                            mr_id: "1835150919",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 670,
                            under_review_duration_sec: 13554,
                            approval_to_merge_duration_sec: 150623,
                        },
                        {
                            mr_id: "1841164276",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 27,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 132,
                        },
                        {
                            mr_id: "1842952705",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 33,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 124,
                        },
                        {
                            mr_id: "1832231279",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3884,
                            under_review_duration_sec: 247171,
                            approval_to_merge_duration_sec: 257479,
                        },
                        {
                            mr_id: "1843239051",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 85,
                        },
                        {
                            mr_id: "1843126093",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2705,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 620,
                        },
                        {
                            mr_id: "1839335692",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 91,
                        },
                        {
                            mr_id: "1842980036",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 69,
                        },
                        {
                            mr_id: "1843192515",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 82,
                        },
                    ],
                    in_progress_duration_avg: 43562,
                    in_progress_duration_median: 69,
                    in_progress_duration_10th: 28,
                    in_progress_duration_25th: 30,
                    in_progress_duration_75th: 1891,
                    in_progress_duration_90th: 7356,
                    in_progress_duration_95th: 315295,
                    in_progress_duration_99th: 549289,
                    in_progress_duration_adj_avg: 701,
                    under_review_duration_avg: 178766,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 11375,
                    under_review_duration_90th: 313038,
                    under_review_duration_95th: 1213401,
                    under_review_duration_99th: 2043027,
                    under_review_duration_adj_avg: 16045,
                    approved_to_merge_duration_avg: 89723,
                    approved_to_merge_duration_median: 169,
                    approved_to_merge_duration_10th: 77,
                    approved_to_merge_duration_25th: 92,
                    approved_to_merge_duration_75th: 41106,
                    approved_to_merge_duration_90th: 391918,
                    approved_to_merge_duration_95th: 433428,
                    approved_to_merge_duration_99th: 640172,
                    approved_to_merge_duration_adj_avg: 29728,
                },
                {
                    week: "2024-04-29 00:00:00",
                    mrs: [
                        {
                            mr_id: "1845984238",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 30,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 101,
                        },
                        {
                            mr_id: "1846080096",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2080,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 165399,
                        },
                        {
                            mr_id: "1845873947",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 138,
                        },
                        {
                            mr_id: "1849817163",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 27,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 102,
                        },
                        {
                            mr_id: "1849953696",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 351,
                        },
                        {
                            mr_id: "1850014880",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 195,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 76500,
                        },
                        {
                            mr_id: "1849843118",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 567,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3656,
                        },
                        {
                            mr_id: "1845885152",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 84,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2290,
                        },
                        {
                            mr_id: "1849981580",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 264,
                            under_review_duration_sec: 224,
                            approval_to_merge_duration_sec: 17,
                        },
                        {
                            mr_id: "1810031382",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34129,
                            under_review_duration_sec: 119,
                            approval_to_merge_duration_sec: 2203187,
                        },
                        {
                            mr_id: "1851980990",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 44,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 170,
                        },
                        {
                            mr_id: "1851685275",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 27,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 495,
                        },
                        {
                            mr_id: "1849992149",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 168,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 73,
                        },
                        {
                            mr_id: "1837565587",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 384,
                            under_review_duration_sec: 670888,
                            approval_to_merge_duration_sec: 76,
                        },
                        {
                            mr_id: "1846392736",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 6411,
                            under_review_duration_sec: 83471,
                            approval_to_merge_duration_sec: 257161,
                        },
                        {
                            mr_id: "1853796181",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 474,
                            under_review_duration_sec: 2240,
                            approval_to_merge_duration_sec: 9755,
                        },
                        {
                            mr_id: "1837381994",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 633,
                            under_review_duration_sec: 672411,
                            approval_to_merge_duration_sec: 88,
                        },
                        {
                            mr_id: "1737163932",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 71103,
                            under_review_duration_sec: 5011763,
                            approval_to_merge_duration_sec: 855972,
                        },
                        {
                            mr_id: "1829745374",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 43,
                            under_review_duration_sec: 341266,
                            approval_to_merge_duration_sec: 708197,
                        },
                        {
                            mr_id: "1848516220",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 424,
                            under_review_duration_sec: 139,
                            approval_to_merge_duration_sec: 121,
                        },
                        {
                            mr_id: "1841743481",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2298,
                            under_review_duration_sec: 64113,
                            approval_to_merge_duration_sec: 434687,
                        },
                        {
                            mr_id: "1848785462",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 288,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2614,
                        },
                    ],
                    in_progress_duration_avg: 58552,
                    in_progress_duration_median: 195,
                    in_progress_duration_10th: 27,
                    in_progress_duration_25th: 44,
                    in_progress_duration_75th: 508,
                    in_progress_duration_90th: 6411,
                    in_progress_duration_95th: 83962,
                    in_progress_duration_99th: 923710,
                    in_progress_duration_adj_avg: 664,
                    under_review_duration_avg: 204222,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 68036,
                    under_review_duration_90th: 813409,
                    under_review_duration_95th: 1004904,
                    under_review_duration_99th: 1479752,
                    under_review_duration_adj_avg: 73966,
                    approved_to_merge_duration_avg: 214598,
                    approved_to_merge_duration_median: 1392,
                    approved_to_merge_duration_10th: 77,
                    approved_to_merge_duration_25th: 107,
                    approved_to_merge_duration_75th: 143174,
                    approved_to_merge_duration_90th: 680846,
                    approved_to_merge_duration_95th: 848583,
                    approved_to_merge_duration_99th: 1920272,
                    approved_to_merge_duration_adj_avg: 59602,
                },
                {
                    week: "2024-05-06 00:00:00",
                    mrs: [
                        {
                            mr_id: "1852032056",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 508,
                            under_review_duration_sec: 4003,
                            approval_to_merge_duration_sec: 442905,
                        },
                        {
                            mr_id: "1852290904",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 158,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 336246,
                        },
                        {
                            mr_id: "1854051030",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 416322,
                            under_review_duration_sec: 452,
                            approval_to_merge_duration_sec: 52,
                        },
                        {
                            mr_id: "1856464759",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 70,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 870,
                        },
                        {
                            mr_id: "1860237178",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 12964,
                        },
                        {
                            mr_id: "1858833517",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 27,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 114,
                        },
                        {
                            mr_id: "1860966319",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 231,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 285,
                        },
                        {
                            mr_id: "1864160821",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 76,
                        },
                        {
                            mr_id: "1862414668",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 33,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 234,
                        },
                        {
                            mr_id: "1862803072",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 68059,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 57,
                        },
                        {
                            mr_id: "1862436048",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 257,
                            under_review_duration_sec: 33,
                            approval_to_merge_duration_sec: 12,
                        },
                        {
                            mr_id: "1856592579",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3228,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3531,
                        },
                        {
                            mr_id: "1848669791",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 169,
                            under_review_duration_sec: 246105,
                            approval_to_merge_duration_sec: 259231,
                        },
                        {
                            mr_id: "1863866548",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 40,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 38,
                        },
                        {
                            mr_id: "1856167751",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1253,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 103618,
                        },
                        {
                            mr_id: "1857014990",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1509,
                            under_review_duration_sec: 148327,
                            approval_to_merge_duration_sec: 78404,
                        },
                        {
                            mr_id: "1858902841",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3078,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 146545,
                        },
                        {
                            mr_id: "1858236240",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 151,
                            under_review_duration_sec: 18195,
                            approval_to_merge_duration_sec: 65072,
                        },
                        {
                            mr_id: "1862441766",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 75,
                        },
                        {
                            mr_id: "1862400929",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 312,
                            under_review_duration_sec: 127,
                            approval_to_merge_duration_sec: 23,
                        },
                        {
                            mr_id: "1862385243",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1360,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 63,
                        },
                        {
                            mr_id: "1858565736",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1449,
                            under_review_duration_sec: 3378,
                            approval_to_merge_duration_sec: 82622,
                        },
                        {
                            mr_id: "1858705397",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 6173,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 129,
                        },
                        {
                            mr_id: "1863911556",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 311,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4870,
                        },
                        {
                            mr_id: "1851965708",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 83962,
                            under_review_duration_sec: 21732,
                            approval_to_merge_duration_sec: 404155,
                        },
                        {
                            mr_id: "1860986479",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 8320,
                            under_review_duration_sec: 67868,
                            approval_to_merge_duration_sec: 87476,
                        },
                        {
                            mr_id: "1856414286",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 107,
                        },
                    ],
                    in_progress_duration_avg: 85574,
                    in_progress_duration_median: 1078,
                    in_progress_duration_10th: 28,
                    in_progress_duration_25th: 62,
                    in_progress_duration_75th: 6710,
                    in_progress_duration_90th: 102800,
                    in_progress_duration_95th: 378192,
                    in_progress_duration_99th: 1275958,
                    in_progress_duration_adj_avg: 8375,
                    under_review_duration_avg: 13813,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 589,
                    under_review_duration_90th: 66943,
                    under_review_duration_95th: 76306,
                    under_review_duration_99th: 130108,
                    under_review_duration_adj_avg: 3589,
                    approved_to_merge_duration_avg: 75177,
                    approved_to_merge_duration_median: 870,
                    approved_to_merge_duration_10th: 46,
                    approved_to_merge_duration_25th: 76,
                    approved_to_merge_duration_75th: 85049,
                    approved_to_merge_duration_90th: 290037,
                    approved_to_merge_duration_95th: 383782,
                    approved_to_merge_duration_99th: 432830,
                    approved_to_merge_duration_adj_avg: 40305,
                },
                {
                    week: "2024-05-13 00:00:00",
                    mrs: [
                        {
                            mr_id: "1872524032",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 230,
                            under_review_duration_sec: 35548,
                            approval_to_merge_duration_sec: 1255,
                        },
                        {
                            mr_id: "1864468789",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 904,
                            under_review_duration_sec: 1000,
                            approval_to_merge_duration_sec: 251407,
                        },
                        {
                            mr_id: "1871800757",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 865,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 74915,
                        },
                        {
                            mr_id: "1872065267",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1280,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 47,
                        },
                        {
                            mr_id: "1873741836",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 591,
                            under_review_duration_sec: 813,
                            approval_to_merge_duration_sec: 11345,
                        },
                        {
                            mr_id: "1869517035",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 140,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3069,
                        },
                        {
                            mr_id: "1815011437",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 545,
                            under_review_duration_sec: 1367307,
                            approval_to_merge_duration_sec: 1902762,
                        },
                        {
                            mr_id: "1867593246",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 78,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 247,
                        },
                        {
                            mr_id: "1796719308",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 631,
                            under_review_duration_sec: 2244865,
                            approval_to_merge_duration_sec: 1817884,
                        },
                        {
                            mr_id: "1872086614",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 32,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 870,
                        },
                        {
                            mr_id: "1862384360",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2043,
                            under_review_duration_sec: 80849,
                            approval_to_merge_duration_sec: 352825,
                        },
                        {
                            mr_id: "1828271470",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3128,
                            under_review_duration_sec: 1021737,
                            approval_to_merge_duration_sec: 1306886,
                        },
                        {
                            mr_id: "1867529707",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 672,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 56136,
                        },
                        {
                            mr_id: "1866661425",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 12810,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 16459,
                        },
                        {
                            mr_id: "1869687362",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 518,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 177,
                        },
                        {
                            mr_id: "1869267206",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 243,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 3864,
                        },
                        {
                            mr_id: "1871612174",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 154,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4887,
                        },
                        {
                            mr_id: "1859067332",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 103471,
                            under_review_duration_sec: 66547,
                            approval_to_merge_duration_sec: 445183,
                        },
                        {
                            mr_id: "1871617740",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 75,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 70,
                        },
                        {
                            mr_id: "1871528462",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 476,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 2262,
                        },
                        {
                            mr_id: "1867613973",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 295,
                            under_review_duration_sec: 591,
                            approval_to_merge_duration_sec: 60801,
                        },
                        {
                            mr_id: "1864172962",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 91,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 262905,
                        },
                        {
                            mr_id: "1871150956",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 208,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 501,
                        },
                        {
                            mr_id: "1869252358",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 89,
                        },
                        {
                            mr_id: "1819006585",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 183549,
                            under_review_duration_sec: 1632424,
                            approval_to_merge_duration_sec: 1463150,
                        },
                        {
                            mr_id: "1868903313",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 7894,
                        },
                        {
                            mr_id: "1868879954",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 136,
                        },
                    ],
                    in_progress_duration_avg: 7273,
                    in_progress_duration_median: 386,
                    in_progress_duration_10th: 34,
                    in_progress_duration_25th: 124,
                    in_progress_duration_75th: 885,
                    in_progress_duration_90th: 13005,
                    in_progress_duration_95th: 59530,
                    in_progress_duration_99th: 71925,
                    in_progress_duration_adj_avg: 1079,
                    under_review_duration_avg: 56650,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 702,
                    under_review_duration_90th: 77470,
                    under_review_duration_95th: 382172,
                    under_review_duration_99th: 681375,
                    under_review_duration_adj_avg: 2180,
                    approved_to_merge_duration_avg: 298075,
                    approved_to_merge_duration_median: 7894,
                    approved_to_merge_duration_10th: 117,
                    approved_to_merge_duration_25th: 686,
                    approved_to_merge_duration_75th: 257156,
                    approved_to_merge_duration_90th: 1369392,
                    approved_to_merge_duration_95th: 1711464,
                    approved_to_merge_duration_99th: 1880694,
                    approved_to_merge_duration_adj_avg: 136382,
                },
                {
                    week: "2024-05-20 00:00:00",
                    mrs: [
                        {
                            mr_id: "1869410651",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 946,
                            under_review_duration_sec: 87951,
                            approval_to_merge_duration_sec: 597952,
                        },
                        {
                            mr_id: "1883048956",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 24,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 236,
                        },
                        {
                            mr_id: "1873419385",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 73179,
                            under_review_duration_sec: 440969,
                            approval_to_merge_duration_sec: 95396,
                        },
                        {
                            mr_id: "1859134506",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3,
                            under_review_duration_sec: 1284106,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1883040256",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 75,
                        },
                        {
                            mr_id: "1878429768",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 27,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 126,
                        },
                        {
                            mr_id: "1874164561",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 322851,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 7396,
                        },
                        {
                            mr_id: "1878589042",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 607,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 998,
                        },
                        {
                            mr_id: "1878705425",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 95883,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 639,
                        },
                        {
                            mr_id: "1879143440",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 78773,
                            under_review_duration_sec: 83551,
                            approval_to_merge_duration_sec: 5767,
                        },
                        {
                            mr_id: "1881537161",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 234,
                            under_review_duration_sec: 36214,
                            approval_to_merge_duration_sec: 6482,
                        },
                        {
                            mr_id: "1883286580",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 191,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 327,
                        },
                        {
                            mr_id: "1885395639",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 297,
                            under_review_duration_sec: 123,
                            approval_to_merge_duration_sec: 2442,
                        },
                        {
                            mr_id: "1832593145",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1133647,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1903727,
                        },
                        {
                            mr_id: "1875719401",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 13089,
                            under_review_duration_sec: 265427,
                            approval_to_merge_duration_sec: 169597,
                        },
                        {
                            mr_id: "1878439043",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 43,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1563,
                        },
                        {
                            mr_id: "1871463741",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 67725,
                            under_review_duration_sec: 6645,
                            approval_to_merge_duration_sec: 688214,
                        },
                        {
                            mr_id: "1883140894",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 405,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 5629,
                        },
                        {
                            mr_id: "1830677280",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 178707,
                            under_review_duration_sec: 954406,
                            approval_to_merge_duration_sec: 1897613,
                        },
                        {
                            mr_id: "1879065902",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 8402,
                            under_review_duration_sec: 1063,
                            approval_to_merge_duration_sec: 3026,
                        },
                        {
                            mr_id: "1835560110",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1662171,
                            under_review_duration_sec: 756545,
                            approval_to_merge_duration_sec: 695568,
                        },
                        {
                            mr_id: "1887300197",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1841,
                            under_review_duration_sec: 2138,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1862864717",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 96757,
                            under_review_duration_sec: 414863,
                            approval_to_merge_duration_sec: 896020,
                        },
                        {
                            mr_id: "1883206836",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 537,
                            under_review_duration_sec: 521,
                            approval_to_merge_duration_sec: 870,
                        },
                        {
                            mr_id: "1881550312",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1171,
                            under_review_duration_sec: 215464,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1878976608",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 84718,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1056,
                        },
                        {
                            mr_id: "1878317267",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 232,
                            under_review_duration_sec: 2605,
                            approval_to_merge_duration_sec: 866,
                        },
                        {
                            mr_id: "1883355784",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 588,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 63516,
                        },
                        {
                            mr_id: "1882860681",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 231,
                            under_review_duration_sec: 3845,
                            approval_to_merge_duration_sec: 1196,
                        },
                        {
                            mr_id: "1886977494",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 27,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 85,
                        },
                        {
                            mr_id: "1882686826",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 269,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 12030,
                        },
                        {
                            mr_id: "1876551181",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 852,
                            under_review_duration_sec: 226758,
                            approval_to_merge_duration_sec: 81326,
                        },
                        {
                            mr_id: "1881118587",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 70,
                            under_review_duration_sec: 173,
                            approval_to_merge_duration_sec: 1553,
                        },
                        {
                            mr_id: "1880956228",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1211,
                            under_review_duration_sec: 409,
                            approval_to_merge_duration_sec: 74291,
                        },
                        {
                            mr_id: "1880713851",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 86312,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 11723,
                        },
                        {
                            mr_id: "1871732603",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 415332,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 6845,
                        },
                        {
                            mr_id: "1878864521",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3128,
                            under_review_duration_sec: 72396,
                            approval_to_merge_duration_sec: 173124,
                        },
                    ],
                    in_progress_duration_avg: 45015,
                    in_progress_duration_median: 732,
                    in_progress_duration_10th: 35,
                    in_progress_duration_25th: 234,
                    in_progress_duration_75th: 7725,
                    in_progress_duration_90th: 155682,
                    in_progress_duration_95th: 295575,
                    in_progress_duration_99th: 382964,
                    in_progress_duration_adj_avg: 13582,
                    under_review_duration_avg: 86580,
                    under_review_duration_median: 291,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 63350,
                    under_review_duration_90th: 228488,
                    under_review_duration_95th: 326867,
                    under_review_duration_99th: 1005871,
                    under_review_duration_adj_avg: 24133,
                    approved_to_merge_duration_avg: 200197,
                    approved_to_merge_duration_median: 5629,
                    approved_to_merge_duration_10th: 81,
                    approved_to_merge_duration_25th: 866,
                    approved_to_merge_duration_75th: 81326,
                    approved_to_merge_duration_90th: 691156,
                    approved_to_merge_duration_95th: 1096339,
                    approved_to_merge_duration_99th: 1901526,
                    approved_to_merge_duration_adj_avg: 69458,
                },
                {
                    week: "2024-05-27 00:00:00",
                    mrs: [
                        {
                            mr_id: "1885481854",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1780,
                            under_review_duration_sec: 75413,
                            approval_to_merge_duration_sec: 513622,
                        },
                        {
                            mr_id: "1890641042",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 206,
                            under_review_duration_sec: 73665,
                            approval_to_merge_duration_sec: 9852,
                        },
                        {
                            mr_id: "1852178382",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 346994,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1805276,
                        },
                        {
                            mr_id: "1890610053",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 96569,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 86062,
                        },
                        {
                            mr_id: "1890684704",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 91792,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 86976,
                        },
                        {
                            mr_id: "1887647588",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 400,
                            under_review_duration_sec: 260821,
                            approval_to_merge_duration_sec: 163995,
                        },
                        {
                            mr_id: "1894511852",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 345,
                            under_review_duration_sec: 4686,
                            approval_to_merge_duration_sec: 65640,
                        },
                        {
                            mr_id: "1894727301",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 8969,
                            under_review_duration_sec: 1834,
                            approval_to_merge_duration_sec: 66854,
                        },
                        {
                            mr_id: "1887589117",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 856,
                            under_review_duration_sec: 240167,
                            approval_to_merge_duration_sec: 180178,
                        },
                        {
                            mr_id: "1892358919",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 165,
                            under_review_duration_sec: 375,
                            approval_to_merge_duration_sec: 6521,
                        },
                        {
                            mr_id: "1890636488",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 94927,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 70280,
                        },
                        {
                            mr_id: "1894230632",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 47,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 111,
                        },
                        {
                            mr_id: "1894246338",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 32,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 887,
                        },
                        {
                            mr_id: "1887359650",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2231,
                            under_review_duration_sec: 432852,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1896328103",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 241,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 462,
                        },
                        {
                            mr_id: "1896126536",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 52,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 471,
                        },
                        {
                            mr_id: "1887146749",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 215480,
                            under_review_duration_sec: 430212,
                            approval_to_merge_duration_sec: 2193,
                        },
                        {
                            mr_id: "1887262097",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2081,
                            under_review_duration_sec: 3316,
                            approval_to_merge_duration_sec: 426570,
                        },
                    ],
                    in_progress_duration_avg: 77065,
                    in_progress_duration_median: 392,
                    in_progress_duration_10th: 32,
                    in_progress_duration_25th: 137,
                    in_progress_duration_75th: 92576,
                    in_progress_duration_90th: 97397,
                    in_progress_duration_95th: 144018,
                    in_progress_duration_99th: 739360,
                    in_progress_duration_adj_avg: 34262,
                    under_review_duration_avg: 91189,
                    under_review_duration_median: 4686,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 98818,
                    under_review_duration_90th: 260821,
                    under_review_duration_95th: 430212,
                    under_review_duration_99th: 432324,
                    under_review_duration_adj_avg: 55363,
                    approved_to_merge_duration_avg: 193664,
                    approved_to_merge_duration_median: 66247,
                    approved_to_merge_duration_10th: 357,
                    approved_to_merge_duration_25th: 1214,
                    approved_to_merge_duration_75th: 144740,
                    approved_to_merge_duration_90th: 452686,
                    approved_to_merge_duration_95th: 707370,
                    approved_to_merge_duration_99th: 1585695,
                    approved_to_merge_duration_adj_avg: 83353,
                },
                {
                    week: "2024-06-03 00:00:00",
                    mrs: [
                        {
                            mr_id: "1894795140",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 26,
                            under_review_duration_sec: 63705,
                            approval_to_merge_duration_sec: 344092,
                        },
                        {
                            mr_id: "1901550114",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 60,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1921,
                        },
                        {
                            mr_id: "1896546640",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 75393,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 259448,
                        },
                        {
                            mr_id: "1901452952",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 989,
                            under_review_duration_sec: 14,
                            approval_to_merge_duration_sec: 828,
                        },
                        {
                            mr_id: "1901176886",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 187,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 5815,
                        },
                        {
                            mr_id: "1899519718",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 99538,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 111360,
                        },
                    ],
                    in_progress_duration_avg: 76476,
                    in_progress_duration_median: 670,
                    in_progress_duration_10th: 2,
                    in_progress_duration_25th: 92,
                    in_progress_duration_75th: 74901,
                    in_progress_duration_90th: 193375,
                    in_progress_duration_95th: 348564,
                    in_progress_duration_99th: 472716,
                    in_progress_duration_adj_avg: 32625,
                    under_review_duration_avg: 16714,
                    under_review_duration_median: 7,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 9093,
                    under_review_duration_90th: 50134,
                    under_review_duration_95th: 69141,
                    under_review_duration_99th: 84348,
                    under_review_duration_adj_avg: 2427,
                    approved_to_merge_duration_avg: 120577,
                    approved_to_merge_duration_median: 58588,
                    approved_to_merge_duration_10th: 1374,
                    approved_to_merge_duration_25th: 2894,
                    approved_to_merge_duration_75th: 222426,
                    approved_to_merge_duration_90th: 301770,
                    approved_to_merge_duration_95th: 322931,
                    approved_to_merge_duration_99th: 339860,
                    approved_to_merge_duration_adj_avg: 94636,
                },
                {
                    week: "2024-06-10 00:00:00",
                    mrs: [
                        {
                            mr_id: "1917305014",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 178013,
                            under_review_duration_sec: 11,
                            approval_to_merge_duration_sec: 3788,
                        },
                        {
                            mr_id: "1883495274",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 292,
                            under_review_duration_sec: 1980935,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1915412407",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 55770,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1603,
                        },
                        {
                            mr_id: "1913082473",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2,
                            under_review_duration_sec: 65130,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1901733464",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2,
                            under_review_duration_sec: 583541,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1915048329",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 12374,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 62152,
                        },
                        {
                            mr_id: "1901497153",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1,
                            under_review_duration_sec: 590664,
                            approval_to_merge_duration_sec: 0,
                        },
                    ],
                    in_progress_duration_avg: 34476,
                    in_progress_duration_median: 8430,
                    in_progress_duration_10th: 96,
                    in_progress_duration_25th: 297,
                    in_progress_duration_75th: 46097,
                    in_progress_duration_90th: 86317,
                    in_progress_duration_95th: 132165,
                    in_progress_duration_99th: 168843,
                    in_progress_duration_adj_avg: 20843,
                    under_review_duration_avg: 361930,
                    under_review_duration_median: 110144,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 3,
                    under_review_duration_75th: 498622,
                    under_review_duration_90th: 729691,
                    under_review_duration_95th: 1355313,
                    under_review_duration_99th: 1855811,
                    under_review_duration_adj_avg: 182041,
                    approved_to_merge_duration_avg: 9649,
                    approved_to_merge_duration_median: 0,
                    approved_to_merge_duration_10th: 0,
                    approved_to_merge_duration_25th: 0,
                    approved_to_merge_duration_75th: 2696,
                    approved_to_merge_duration_90th: 27134,
                    approved_to_merge_duration_95th: 44643,
                    approved_to_merge_duration_99th: 58650,
                    approved_to_merge_duration_adj_avg: 899,
                },
                {
                    week: "2024-06-17 00:00:00",
                    mrs: [
                        {
                            mr_id: "1921195952",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 600,
                            under_review_duration_sec: 240554,
                            approval_to_merge_duration_sec: 179310,
                        },
                        {
                            mr_id: "1901175703",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 503754,
                            under_review_duration_sec: 88149,
                            approval_to_merge_duration_sec: 1389516,
                        },
                        {
                            mr_id: "1913088182",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 17079,
                            under_review_duration_sec: 243864,
                            approval_to_merge_duration_sec: 372799,
                        },
                        {
                            mr_id: "1917359201",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 76129,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 370697,
                        },
                    ],
                    in_progress_duration_avg: 105534,
                    in_progress_duration_median: 1768,
                    in_progress_duration_10th: 123,
                    in_progress_duration_25th: 366,
                    in_progress_duration_75th: 6019,
                    in_progress_duration_90th: 212996,
                    in_progress_duration_95th: 585707,
                    in_progress_duration_99th: 1091285,
                    in_progress_duration_adj_avg: 11429,
                    under_review_duration_avg: 56395,
                    under_review_duration_median: 3901,
                    under_review_duration_10th: 719,
                    under_review_duration_25th: 1567,
                    under_review_duration_75th: 11055,
                    under_review_duration_90th: 196101,
                    under_review_duration_95th: 319655,
                    under_review_duration_99th: 414576,
                    under_review_duration_adj_avg: 5940,
                    approved_to_merge_duration_avg: 578081,
                    approved_to_merge_duration_median: 371748,
                    approved_to_merge_duration_10th: 236726,
                    approved_to_merge_duration_25th: 322850,
                    approved_to_merge_duration_75th: 626978,
                    approved_to_merge_duration_90th: 1084501,
                    approved_to_merge_duration_95th: 1237008,
                    approved_to_merge_duration_99th: 1359014,
                    approved_to_merge_duration_adj_avg: 371748,
                },
                {
                    week: "2024-06-24 00:00:00",
                    mrs: [
                        {
                            mr_id: "1932732674",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 442,
                            under_review_duration_sec: 2072,
                            approval_to_merge_duration_sec: 257962,
                        },
                        {
                            mr_id: "1890855908",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 888195,
                            under_review_duration_sec: 2493252,
                            approval_to_merge_duration_sec: 9621,
                        },
                        {
                            mr_id: "1932829304",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2247,
                            under_review_duration_sec: 6582,
                            approval_to_merge_duration_sec: 610885,
                        },
                        {
                            mr_id: "1932890519",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1280,
                            under_review_duration_sec: 3901,
                            approval_to_merge_duration_sec: 608054,
                        },
                        {
                            mr_id: "1938379856",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 413975,
                            under_review_duration_sec: 86050,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1943166958",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 413,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 63548,
                        },
                        {
                            mr_id: "1938018793",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 871449,
                            under_review_duration_sec: 12260,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1932852113",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 103,
                            under_review_duration_sec: 5637,
                            approval_to_merge_duration_sec: 606209,
                        },
                    ],
                    in_progress_duration_avg: 472050,
                    in_progress_duration_median: 213113,
                    in_progress_duration_10th: 1144,
                    in_progress_duration_25th: 53826,
                    in_progress_duration_75th: 528344,
                    in_progress_duration_90th: 1207493,
                    in_progress_duration_95th: 1599544,
                    in_progress_duration_99th: 1913185,
                    in_progress_duration_adj_avg: 297398,
                    under_review_duration_avg: 383764,
                    under_review_duration_median: 66576,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 9195,
                    under_review_duration_75th: 150886,
                    under_review_duration_90th: 989751,
                    under_review_duration_95th: 1741502,
                    under_review_duration_99th: 2342902,
                    under_review_duration_adj_avg: 82408,
                    approved_to_merge_duration_avg: 269535,
                    approved_to_merge_duration_median: 160755,
                    approved_to_merge_duration_10th: 0,
                    approved_to_merge_duration_25th: 7216,
                    approved_to_merge_duration_75th: 606670,
                    approved_to_merge_duration_90th: 608903,
                    approved_to_merge_duration_95th: 609894,
                    approved_to_merge_duration_99th: 610687,
                    approved_to_merge_duration_adj_avg: 220771,
                },
                {
                    week: "2024-07-01 00:00:00",
                    mrs: [
                        {
                            mr_id: "1950214686",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 21,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 129,
                        },
                        {
                            mr_id: "1950203533",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 39,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 174,
                        },
                        {
                            mr_id: "1951943836",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 60,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 579,
                        },
                        {
                            mr_id: "1949457798",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 62035,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 7572,
                        },
                        {
                            mr_id: "1949754785",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 36,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 51,
                        },
                        {
                            mr_id: "1952358277",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 88,
                        },
                        {
                            mr_id: "1933079645",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1082,
                            under_review_duration_sec: 345394,
                            approval_to_merge_duration_sec: 516389,
                        },
                        {
                            mr_id: "1950306372",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1114,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 243596,
                        },
                        {
                            mr_id: "1944520830",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 71282,
                            under_review_duration_sec: 263831,
                            approval_to_merge_duration_sec: 7214,
                        },
                        {
                            mr_id: "1949887479",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 176,
                        },
                        {
                            mr_id: "1951964293",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 27,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 212,
                        },
                        {
                            mr_id: "1952319330",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 305,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 105,
                        },
                        {
                            mr_id: "1949861781",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 28,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 188,
                        },
                        {
                            mr_id: "1950263157",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 24,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 32,
                        },
                        {
                            mr_id: "1951890273",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2488,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 161,
                        },
                        {
                            mr_id: "1952004578",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 22,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 114,
                        },
                        {
                            mr_id: "1952334363",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 151,
                        },
                    ],
                    in_progress_duration_avg: 16325,
                    in_progress_duration_median: 39,
                    in_progress_duration_10th: 24,
                    in_progress_duration_25th: 28,
                    in_progress_duration_75th: 1801,
                    in_progress_duration_90th: 36463,
                    in_progress_duration_95th: 74655,
                    in_progress_duration_99th: 165519,
                    in_progress_duration_adj_avg: 3991,
                    under_review_duration_avg: 81112,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 0,
                    under_review_duration_90th: 79149,
                    under_review_duration_95th: 403685,
                    under_review_duration_99th: 1037690,
                    under_review_duration_adj_avg: 0,
                    approved_to_merge_duration_avg: 45702,
                    approved_to_merge_duration_median: 174,
                    approved_to_merge_duration_10th: 73,
                    approved_to_merge_duration_25th: 114,
                    approved_to_merge_duration_75th: 579,
                    approved_to_merge_duration_90th: 101982,
                    approved_to_merge_duration_95th: 298155,
                    approved_to_merge_duration_99th: 472742,
                    approved_to_merge_duration_adj_avg: 1297,
                },
                {
                    week: "2024-07-08 00:00:00",
                    mrs: [
                        {
                            mr_id: "1957956471",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 196917,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 62392,
                        },
                        {
                            mr_id: "1965067552",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 236,
                            under_review_duration_sec: 1612,
                            approval_to_merge_duration_sec: 774,
                        },
                        {
                            mr_id: "1932758476",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 315,
                            under_review_duration_sec: 636,
                            approval_to_merge_duration_sec: 1471305,
                        },
                        {
                            mr_id: "1912602574",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2429000,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 13393,
                        },
                        {
                            mr_id: "1965473420",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 456,
                            under_review_duration_sec: 54071,
                            approval_to_merge_duration_sec: 11363,
                        },
                        {
                            mr_id: "1960375155",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 321,
                            under_review_duration_sec: 922,
                            approval_to_merge_duration_sec: 257542,
                        },
                        {
                            mr_id: "1932735128",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 69851,
                            under_review_duration_sec: 1567,
                            approval_to_merge_duration_sec: 1470547,
                        },
                        {
                            mr_id: "1960639090",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 428725,
                            under_review_duration_sec: 15125,
                            approval_to_merge_duration_sec: 235634,
                        },
                        {
                            mr_id: "1958313900",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1353,
                            under_review_duration_sec: 5155,
                            approval_to_merge_duration_sec: 269360,
                        },
                        {
                            mr_id: "1927071993",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1217679,
                            under_review_duration_sec: 1196191,
                            approval_to_merge_duration_sec: 693775,
                        },
                        {
                            mr_id: "1962911517",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 51,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 372,
                        },
                        {
                            mr_id: "1962351842",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 40,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 146,
                        },
                        {
                            mr_id: "1917072391",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 107,
                            under_review_duration_sec: 155159,
                            approval_to_merge_duration_sec: 2365570,
                        },
                        {
                            mr_id: "1958557184",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 33,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 312,
                        },
                        {
                            mr_id: "1958579501",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 119,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 79269,
                        },
                        {
                            mr_id: "1958781066",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 196,
                            under_review_duration_sec: 9,
                            approval_to_merge_duration_sec: 1041,
                        },
                        {
                            mr_id: "1952748163",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25505,
                            under_review_duration_sec: 468241,
                            approval_to_merge_duration_sec: 8973,
                        },
                        {
                            mr_id: "1960981107",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 16043,
                            under_review_duration_sec: 649,
                            approval_to_merge_duration_sec: 151517,
                        },
                        {
                            mr_id: "1943136526",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 101268,
                            under_review_duration_sec: 71451,
                            approval_to_merge_duration_sec: 858563,
                        },
                        {
                            mr_id: "1932749632",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 366,
                            under_review_duration_sec: 1053,
                            approval_to_merge_duration_sec: 1464729,
                        },
                        {
                            mr_id: "1965014255",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 60,
                            under_review_duration_sec: 1844,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1960866352",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 6654,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 612,
                        },
                        {
                            mr_id: "1958635638",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 128,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 238211,
                        },
                        {
                            mr_id: "1884906163",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3985800,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 7954,
                        },
                        {
                            mr_id: "1962739621",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 34,
                            under_review_duration_sec: 60,
                            approval_to_merge_duration_sec: 120,
                        },
                        {
                            mr_id: "1962381141",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 25,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 146,
                        },
                        {
                            mr_id: "1964878220",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 141,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 4078,
                        },
                        {
                            mr_id: "1964762421",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 35,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 479,
                        },
                        {
                            mr_id: "1915006117",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 2335915,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 267041,
                        },
                        {
                            mr_id: "1952043182",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 68,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 504897,
                        },
                        {
                            mr_id: "1952808579",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 30070,
                            under_review_duration_sec: 376995,
                            approval_to_merge_duration_sec: 96821,
                        },
                        {
                            mr_id: "1960541915",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 505962,
                            under_review_duration_sec: 181,
                            approval_to_merge_duration_sec: 13716,
                        },
                        {
                            mr_id: "1964757531",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 53,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 12567,
                        },
                        {
                            mr_id: "1962840716",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 31,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 31,
                        },
                        {
                            mr_id: "1964800548",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 330,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 1415,
                        },
                        {
                            mr_id: "1964890729",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 110,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 91,
                        },
                        {
                            mr_id: "1962922621",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 29,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 59,
                        },
                        {
                            mr_id: "1960950350",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 355,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 303,
                        },
                        {
                            mr_id: "1958811042",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 269,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 102,
                        },
                    ],
                    in_progress_duration_avg: 384096,
                    in_progress_duration_median: 330,
                    in_progress_duration_10th: 34,
                    in_progress_duration_25th: 60,
                    in_progress_duration_75th: 180947,
                    in_progress_duration_90th: 1290386,
                    in_progress_duration_95th: 2548489,
                    in_progress_duration_99th: 3640433,
                    in_progress_duration_adj_avg: 83940,
                    under_review_duration_avg: 47055,
                    under_review_duration_median: 0,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 1786,
                    under_review_duration_90th: 117723,
                    under_review_duration_95th: 390682,
                    under_review_duration_99th: 544918,
                    under_review_duration_adj_avg: 2549,
                    approved_to_merge_duration_avg: 270903,
                    approved_to_merge_duration_median: 11363,
                    approved_to_merge_duration_10th: 100,
                    approved_to_merge_duration_25th: 342,
                    approved_to_merge_duration_75th: 247876,
                    approved_to_merge_duration_90th: 979796,
                    approved_to_merge_duration_95th: 1470623,
                    approved_to_merge_duration_99th: 2025749,
                    approved_to_merge_duration_adj_avg: 122351,
                },
                {
                    week: "2024-07-15 00:00:00",
                    mrs: [
                        {
                            mr_id: "1952424499",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 188235,
                            under_review_duration_sec: 589951,
                            approval_to_merge_duration_sec: 428924,
                        },
                        {
                            mr_id: "1969788253",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 123,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 8405,
                        },
                        {
                            mr_id: "1962828841",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 426,
                            under_review_duration_sec: 1057,
                            approval_to_merge_duration_sec: 709681,
                        },
                        {
                            mr_id: "1974682780",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 0,
                            under_review_duration_sec: 78958,
                            approval_to_merge_duration_sec: 0,
                        },
                        {
                            mr_id: "1960268134",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1685,
                            under_review_duration_sec: 364,
                            approval_to_merge_duration_sec: 633453,
                        },
                        {
                            mr_id: "1970359898",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 285,
                            under_review_duration_sec: 362,
                            approval_to_merge_duration_sec: 48669,
                        },
                        {
                            mr_id: "1967002122",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 593366,
                            under_review_duration_sec: 258797,
                            approval_to_merge_duration_sec: 338658,
                        },
                        {
                            mr_id: "1962771256",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 418796,
                            under_review_duration_sec: 3123,
                            approval_to_merge_duration_sec: 701895,
                        },
                        {
                            mr_id: "1942892797",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 1991595,
                            under_review_duration_sec: 1656002,
                            approval_to_merge_duration_sec: 170213,
                        },
                    ],
                    in_progress_duration_avg: 241360,
                    in_progress_duration_median: 228,
                    in_progress_duration_10th: 2,
                    in_progress_duration_25th: 97,
                    in_progress_duration_75th: 719,
                    in_progress_duration_90th: 725812,
                    in_progress_duration_95th: 1265740,
                    in_progress_duration_99th: 1697682,
                    in_progress_duration_adj_avg: 75992,
                    under_review_duration_avg: 224332,
                    under_review_duration_median: 2674,
                    under_review_duration_10th: 0,
                    under_review_duration_25th: 0,
                    under_review_duration_75th: 78958,
                    under_review_duration_90th: 538238,
                    under_review_duration_95th: 1097120,
                    under_review_duration_99th: 1544226,
                    under_review_duration_adj_avg: 45373,
                    approved_to_merge_duration_avg: 337766,
                    approved_to_merge_duration_median: 338658,
                    approved_to_merge_duration_10th: 6724,
                    approved_to_merge_duration_25th: 48669,
                    approved_to_merge_duration_75th: 633453,
                    approved_to_merge_duration_90th: 703452,
                    approved_to_merge_duration_95th: 706567,
                    approved_to_merge_duration_99th: 709058,
                    approved_to_merge_duration_adj_avg: 332888,
                },
                {
                    week: "2024-07-22 00:00:00",
                    mrs: [
                        {
                            mr_id: "1967205383",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 80447,
                            under_review_duration_sec: 858008,
                            approval_to_merge_duration_sec: 103660,
                        },
                        {
                            mr_id: "1985756903",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 384,
                            under_review_duration_sec: 2700,
                            approval_to_merge_duration_sec: 9029,
                        },
                        {
                            mr_id: "1982198129",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 3193,
                            under_review_duration_sec: 58594,
                            approval_to_merge_duration_sec: 100336,
                        },
                        {
                            mr_id: "1970039612",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 88,
                            under_review_duration_sec: 0,
                            approval_to_merge_duration_sec: 780392,
                        },
                        {
                            mr_id: "1978394673",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 359898,
                            under_review_duration_sec: 350,
                            approval_to_merge_duration_sec: 66865,
                        },
                        {
                            mr_id: "1981897209",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 473,
                            under_review_duration_sec: 78157,
                            approval_to_merge_duration_sec: 80776,
                        },
                        {
                            mr_id: "1920789020",
                            hostname_repo_full_name: "https://api.github.com:demo/demo",
                            in_progress_duration_sec: 196,
                            under_review_duration_sec: 3464700,
                            approval_to_merge_duration_sec: 0,
                        },
                    ],
                    in_progress_duration_avg: 146343,
                    in_progress_duration_median: 76480,
                    in_progress_duration_10th: 380,
                    in_progress_duration_25th: 526,
                    in_progress_duration_75th: 318937,
                    in_progress_duration_90th: 353742,
                    in_progress_duration_95th: 356820,
                    in_progress_duration_99th: 359282,
                    in_progress_duration_adj_avg: 137899,
                    under_review_duration_avg: 406269,
                    under_review_duration_median: 2433,
                    under_review_duration_10th: 350,
                    under_review_duration_25th: 1288,
                    under_review_duration_75th: 68376,
                    under_review_duration_90th: 858008,
                    under_review_duration_95th: 2161354,
                    under_review_duration_99th: 3204031,
                    under_review_duration_adj_avg: 111584,
                    approved_to_merge_duration_avg: 163008,
                    approved_to_merge_duration_median: 80776,
                    approved_to_merge_duration_10th: 5417,
                    approved_to_merge_duration_25th: 37947,
                    approved_to_merge_duration_75th: 101998,
                    approved_to_merge_duration_90th: 374353,
                    approved_to_merge_duration_95th: 577372,
                    approved_to_merge_duration_99th: 739788,
                    approved_to_merge_duration_adj_avg: 72133,
                },
            ],
            baseline: {
                in_progress_duration_adj_avg: 54275,
                in_progress_duration_avg: 201982,
                in_progress_duration_median: 715,
                in_progress_duration_25th: 108,
                in_progress_duration_75th: 81968,
                in_progress_duration_90th: 428725,
                in_progress_duration_95th: 1052937,
                in_progress_duration_99th: 2847212,
                under_review_duration_adj_avg: 31055,
                under_review_duration_avg: 155612,
                under_review_duration_median: 1053,
                under_review_duration_25th: 0,
                under_review_duration_75th: 68290,
                under_review_duration_90th: 364355,
                under_review_duration_95th: 670867,
                under_review_duration_99th: 2421528,
                approved_to_merge_duration_adj_avg: 121193,
                approved_to_merge_duration_avg: 220431,
                approved_to_merge_duration_median: 9029,
                approved_to_merge_duration_25th: 156,
                approved_to_merge_duration_75th: 257752,
                approved_to_merge_duration_90th: 693775,
                approved_to_merge_duration_95th: 1124039,
                approved_to_merge_duration_99th: 1560731,
            },
            inProgressDelta: -28304,
            underReviewDelta: -23408,
            approvedToMergeDelta: -75236,
        },
    };
};

export default getMrTimings;
